import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { Col, DatePicker, Row, Select, Form, Input, Upload, Button, Tooltip, Popconfirm, Spin, message } from "antd";
import { UploadOutlined, PaperClipOutlined, SaveOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ReactComponent as EditOutlined } from "../../../../assets/edit-icon.svg";
import { ReactComponent as AuthorizeIcon } from "../../../../assets/476dab3b4f69c5886bdab2c64c134f28_e20f00.svg";
import SpinnerComponent from "../../../../components/spinner";
import ShippingButton from "./ShippingButton";
import DeliveryNotesList from "./DeliveryNotesList";
import AuthorizeExcess from "./AuthorizeExcess";
import AttachmentContainer from "./AttachmentContainter";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { fetchProjectPriorities } from "../../../ProjectSetup/redux/actions";
import { fetchSuppliers } from "../../../supplier/redux/actions";
import { fetchCommodities } from "../../../commodity/redux/actions";
import { fetchUser } from "../../../UserManager/redux/actions";
import { fetchMaterialTypes } from "../../../materialTypes/redux/actions";
import "./expandedRow.css";
import { fetchAllLocations } from "../../../LocationManager/redux/actions";
import { markItemAsReceived, markItemAsCompleted, markItemAsReceivedUpdate, fetchMaterialControlById, resetNewMaterialControl, fetchMaterialControl } from "../../redux/actions";
import axios from "axios";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import {
  updateMaterialControl,
} from "../../redux/actions";
import GrvList from "./GrvList";
import { log } from "@craco/craco/lib/logger";

import { fetchAllUserProjects } from "../../../UserManager/redux/actions";

const { Option } = Select;

const ExpandedRow = ({ fields, formRef, onFinish, isRevisionUpdateCase, record, project_id, isEditing, editingKey, editingLoading, mcPermissions, onTrackingStageStatusUpdate, refetchParams}) => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({documents: []});
  const [isSaving, setIsSaving] = useState(false);
  const [user, setUser] = useState(null);
  const [qcDeliveryNotesCount, setQcDeliveryNotesCount] = useState(0);
  const [corrosionDeliveryNotesCount, setCorrosionDeliveryNotesCount] = useState(0);
  const [siteReceiptDeliveryNotesCount, setSiteReceiptDeliveryNotesCount] = useState(0);
  const [deliveryToSiteDeliveryNotesCount, setDeliveryToSiteDeliveryNotesCount] = useState(0);
  const [corrisonSignedDeliveryNote, setCorrisonSignedDeliveryNote] = useState(false);
  const [deliveryToSiteSignedDeliveryNote, setDeliveryToSiteSignedDeliveryNote] = useState(false);
  const [siteReceiptSignedDeliveryNote, setSiteReceiptSignedDeliveryNote] = useState(false);
  const [localSignedDeliveryNoteAttachments, setLocalSignedDeliveryNoteAttachments] = useState([]);
  const [datePickerVisible, setDatePickerVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [dateIsSaved, setDateIsSaved] = useState(false);
  const [receivedQty, setReceivedQty] = useState('');
  const [qtyInputVisible, setQtyInputVisible] = useState(false);
  const [qtyIsSaved, setQtyIsSaved] = useState(false);
  const [projectStages, setProjectStages] = useState(null);
  const [fabrication, setFabrication] = useState(null);
  const [qcRelease, setQcRelease] = useState(null);
  const [corrosionProtection, setCorrosionProtection] = useState(null);
  const [deliveryToSite, setDeliveryToSite] = useState(null);
  const [siteReceipt, setSiteReceipt] = useState(null);
  const [installation, setInstallation] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [updatedByUser, setUpdatedByUser] = useState('');
  const [statusBadge, setStatusBadge] = useState('');
  const [isItemReceived, setIsItemReceived] = useState(false);
  
  // State variables for Fabrication DATE COMPLETED section
  const [completedDatePickerVisible, setCompletedDatePickerVisible] = useState(false);
  const [selectedCompletedDate, setSelectedCompletedDate] = useState(null);
  const [completedDateIsSaved, setCompletedDateIsSaved] = useState(false);
  const [completedQty, setCompletedQty] = useState('');
  const [completedQtyInputVisible, setCompletedQtyInputVisible] = useState(false);
  const [completedQtyIsSaved, setCompletedQtyIsSaved] = useState(false);
  const [selectedCompletedLocation, setSelectedCompletedLocation] = useState(null);
  const [completedByUser, setCompletedByUser] = useState('');
  const [grossCompleted, setGrossCompleted] = useState('');
  const [isItemCompleted, setIsItemCompleted] = useState(false); // Track if item has been fully completed
  const [isItemInProgress, setIsItemInProgress] = useState(false); // Track if item is in progress (partially completed)
  const [isCompletedAuthorized, setIsCompletedAuthorized] = useState(false); // Track if completed quantity is authorized

  // Authorization dropdown state variables
  const [authorizeDropdownVisible, setAuthorizeDropdownVisible] = useState(false);
  const [authorizeDropdownPosition, setAuthorizeDropdownPosition] = useState({});
  const [authorizeReason, setAuthorizeReason] = useState('');
  const [authorizeLoading, setAuthorizeLoading] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [authorizationData, setAuthorizationData] = useState(null);
  const [authorizationReceivedData, setAuthorizationReceivedData] = useState(null);
  const [authorizationCompletedData, setAuthorizationCompletedData] = useState(null);
  const [authorizationQcReceivedData, setAuthorizationQcReceivedData] = useState(null);
  const [authorizationQcCompletedData, setAuthorizationQcCompletedData] = useState(null);
  const authorizeButtonRef = useRef(null);
  
  // State variables for QC Release DATE COMPLETED section
  const [qcCompletedDatePickerVisible, setQcCompletedDatePickerVisible] = useState(false);
  const [selectedQcCompletedDate, setSelectedQcCompletedDate] = useState(null);
  const [qcCompletedDateIsSaved, setQcCompletedDateIsSaved] = useState(false);
  const [qcCompletedQty, setQcCompletedQty] = useState('');
  const [qcCompletedQtyInputVisible, setQcCompletedQtyInputVisible] = useState(false);
  const [qcCompletedQtyIsSaved, setQcCompletedQtyIsSaved] = useState(false);
  const [selectedQcCompletedLocation, setSelectedQcCompletedLocation] = useState(null);
  const [qcCompletedByUser, setQcCompletedByUser] = useState('');
  const [qcGrossCompleted, setQcGrossCompleted] = useState('');
  const [isQcItemCompleted, setIsQcItemCompleted] = useState(false); // Track if QC item has been fully completed
  const [isQcItemInProgress, setIsQcItemInProgress] = useState(false); // Track if QC item is in progress (partially completed)
  
  // State variables for supplier editing
  const [supplierEditMode, setSupplierEditMode] = useState(false);
  const [qcSupplierEditMode, setQcSupplierEditMode] = useState(false);
  const [corrosionSupplierEditMode, setCorrosionSupplierEditMode] = useState(false);
  const [deliverySupplierEditMode, setDeliverySupplierEditMode] = useState(false);
  const [siteReceiptSupplierEditMode, setSiteReceiptSupplierEditMode] = useState(false);
  const [selectedSupplierForTracking, setSelectedSupplierForTracking] = useState(null);
  const [selectedQcSupplierForTracking, setSelectedQcSupplierForTracking] = useState(null);
  const [selectedCorrosionSupplierForTracking, setSelectedCorrosionSupplierForTracking] = useState(null);
  const [selectedDeliverySupplierForTracking, setSelectedDeliverySupplierForTracking] = useState(null);
  const [selectedSiteReceiptSupplierForTracking, setSelectedSiteReceiptSupplierForTracking] = useState(null);
  
  
  // State variable for QC Release readiness
  const [isQCReleaseReady, setIsQCReleaseReady] = useState(false);
  const [isCorrosionProtectionReady, setIsCorrosionProtectionReady] = useState(false);
  const [isDeliveryToSiteReady, setIsDeliveryToSiteReady] = useState(false);
  const [isSiteReceiptReady, setIsSiteReceiptReady] = useState(false);
  const [isInstallationReady, setIsInstallationReady] = useState(false);
  
  // State variables for QC Release workflow
  const [qcDatePickerVisible, setQcDatePickerVisible] = useState(false);
  const [selectedQcDate, setSelectedQcDate] = useState(null);
  const [qcDateIsSaved, setQcDateIsSaved] = useState(false);
  const [qcQty, setQcQty] = useState('');
  const [qcQtyInputVisible, setQcQtyInputVisible] = useState(false);
  const [qcQtyIsSaved, setQcQtyIsSaved] = useState(false);
  const [selectedQcLocation, setSelectedQcLocation] = useState(null);
  const [qcByUser, setQcByUser] = useState('');
  const [isQcCompleted, setIsQcCompleted] = useState(false);
  const [isQcAuthorized, setIsQcAuthorized] = useState(false);
  const [isQcCompletedAuthorized, setIsQcCompletedAuthorized] = useState(false);

  // State variables for corrosion protection received
  const [corrosionDatePickerVisible, setCorrosionDatePickerVisible] = useState(false);
  const [selectedCorrosionDate, setSelectedCorrosionDate] = useState(null);
  const [corrosionDateIsSaved, setCorrosionDateIsSaved] = useState(false);
  const [corrosionQty, setCorrosionQty] = useState('');
  const [corrosionQtyInputVisible, setCorrosionQtyInputVisible] = useState(false);
  const [corrosionQtyIsSaved, setCorrosionQtyIsSaved] = useState(false);
  const [selectedCorrosionLocation, setSelectedCorrosionLocation] = useState(null);
  const [corrosionByUser, setCorrosionByUser] = useState('');
  const [isCorrosionCompleted, setIsCorrosionCompleted] = useState(false);
  const [isCorrosionAuthorized, setIsCorrosionAuthorized] = useState(false);
  const [authorizationCorrosionReceivedData, setAuthorizationCorrosionReceivedData] = useState({});
  const [authorizationCorrosionCompletedData, setAuthorizationCorrosionCompletedData] = useState({});

  // State variables for corrosion protection completed
  const [corrosionCompletedDatePickerVisible, setCorrosionCompletedDatePickerVisible] = useState(false);
  const [selectedCorrosionCompletedDate, setSelectedCorrosionCompletedDate] = useState(null);
  const [corrosionCompletedDateIsSaved, setCorrosionCompletedDateIsSaved] = useState(false);
  const [corrosionCompletedQty, setCorrosionCompletedQty] = useState('');
  const [corrosionCompletedQtyInputVisible, setCorrosionCompletedQtyInputVisible] = useState(false);
  const [corrosionCompletedQtyIsSaved, setCorrosionCompletedQtyIsSaved] = useState(false);
  const [selectedCorrosionCompletedLocation, setSelectedCorrosionCompletedLocation] = useState(null);
  const [corrosionCompletedByUser, setCorrosionCompletedByUser] = useState('');
  const [isCorrosionCompletedCompleted, setIsCorrosionCompletedCompleted] = useState(false);
  const [corrosionGrossCompleted, setCorrosionGrossCompleted] = useState('');
  const [isCorrosionCompletedAuthorized, setIsCorrosionCompletedAuthorized] = useState(false);

  // State variables for delivery to site - mark received
  const [deliveryDatePickerVisible, setDeliveryDatePickerVisible] = useState(false);
  const [selectedDeliveryDate, setSelectedDeliveryDate] = useState(null);
  const [deliveryDateIsSaved, setDeliveryDateIsSaved] = useState(false);
  const [deliveryQty, setDeliveryQty] = useState('');
  const [deliveryQtyInputVisible, setDeliveryQtyInputVisible] = useState(false);
  const [deliveryQtyIsSaved, setDeliveryQtyIsSaved] = useState(false);
  const [selectedDeliveryLocation, setSelectedDeliveryLocation] = useState(null);
  const [deliveryByUser, setDeliveryByUser] = useState('');
  const [isDeliveryCompleted, setIsDeliveryCompleted] = useState(false);
  const [isDeliveryAuthorized, setIsDeliveryAuthorized] = useState(false);
  const [deliveryGross, setDeliveryGross] = useState('');
  const [authorizationDeliveryReceivedData, setAuthorizationDeliveryReceivedData] = useState(null);
  const [authorizationDeliveryCompletedData, setAuthorizationDeliveryCompletedData] = useState(null);
  
  // State variables for delivery to site - mark completed
  const [deliveryCompletedDatePickerVisible, setDeliveryCompletedDatePickerVisible] = useState(false);
  const [selectedDeliveryCompletedDate, setSelectedDeliveryCompletedDate] = useState(null);
  const [deliveryCompletedDateIsSaved, setDeliveryCompletedDateIsSaved] = useState(false);
  const [deliveryCompletedQty, setDeliveryCompletedQty] = useState('');
  const [deliveryCompletedQtyInputVisible, setDeliveryCompletedQtyInputVisible] = useState(false);
  const [deliveryCompletedQtyIsSaved, setDeliveryCompletedQtyIsSaved] = useState(false);
  const [selectedDeliveryCompletedLocation, setSelectedDeliveryCompletedLocation] = useState(null);
  const [deliveryCompletedByUser, setDeliveryCompletedByUser] = useState('');
  const [isDeliveryItemCompleted, setIsDeliveryItemCompleted] = useState(false);
  const [isDeliveryItemInProgress, setIsDeliveryItemInProgress] = useState(false);
  const [deliveryGrossCompleted, setDeliveryGrossCompleted] = useState('');
  const [isDeliveryCompletedAuthorized, setIsDeliveryCompletedAuthorized] = useState(false);
  
  // State variables for site receipt - mark received
  const [siteReceiptDatePickerVisible, setSiteReceiptDatePickerVisible] = useState(false);
  const [selectedSiteReceiptDate, setSelectedSiteReceiptDate] = useState(null);
  const [siteReceiptDateIsSaved, setSiteReceiptDateIsSaved] = useState(false);
  const [siteReceiptQty, setSiteReceiptQty] = useState('');
  const [siteReceiptQtyInputVisible, setSiteReceiptQtyInputVisible] = useState(false);
  const [siteReceiptQtyIsSaved, setSiteReceiptQtyIsSaved] = useState(false);
  const [selectedSiteReceiptLocation, setSelectedSiteReceiptLocation] = useState(null);
  const [siteReceiptByUser, setSiteReceiptByUser] = useState('');
  const [isSiteReceiptCompleted, setIsSiteReceiptCompleted] = useState(false);
  const [isSiteReceiptAuthorized, setIsSiteReceiptAuthorized] = useState(false);
  const [siteReceiptGross, setSiteReceiptGross] = useState('');
  const [authorizationDeliverytoSiteReceivedData, setAuthorizationDeliverytoSiteReceivedData] = useState(null);
  
  
  // State variables for site receipt - mark completed
  const [siteReceiptCompletedDatePickerVisible, setSiteReceiptCompletedDatePickerVisible] = useState(false);
  const [selectedSiteReceiptCompletedDate, setSelectedSiteReceiptCompletedDate] = useState(null);
  const [siteReceiptCompletedDateIsSaved, setSiteReceiptCompletedDateIsSaved] = useState(false);
  const [siteReceiptCompletedQty, setSiteReceiptCompletedQty] = useState('');
  const [siteReceiptCompletedQtyInputVisible, setSiteReceiptCompletedQtyInputVisible] = useState(false);
  const [siteReceiptCompletedQtyIsSaved, setSiteReceiptCompletedQtyIsSaved] = useState(false);
  const [selectedSiteReceiptCompletedLocation, setSelectedSiteReceiptCompletedLocation] = useState(null);
  const [siteReceiptCompletedByUser, setSiteReceiptCompletedByUser] = useState('');
  const [isSiteReceiptItemCompleted, setIsSiteReceiptItemCompleted] = useState(false);
  const [isSiteReceiptItemInProgress, setIsSiteReceiptItemInProgress] = useState(false);
  const [siteReceiptGrossCompleted, setSiteReceiptGrossCompleted] = useState('');
  const [isSiteReceiptCompletedAuthorized, setIsSiteReceiptCompletedAuthorized] = useState(false);
  const [authorizationDeliverytoSiteCompletedData, setAuthorizationDeliverytoSiteCompletedData] = useState(null);

    // State variables for installation
  const [installationDatePickerVisible, setInstallationDatePickerVisible] = useState(false);
  const [selectedInstallationDate, setSelectedInstallationDate] = useState(null);
  const [installationDateIsSaved, setInstallationDateIsSaved] = useState(false);
  const [installationQty, setInstallationQty] = useState('');
  const [installationQtyInputVisible, setInstallationQtyInputVisible] = useState(false);
  const [installationQtyIsSaved, setInstallationQtyIsSaved] = useState(false);
  const [selectedInstallationLocation, setSelectedInstallationLocation] = useState(null);
  const [installationByUser, setInstallationByUser] = useState('');
  const [isInstallationCompleted, setIsInstallationCompleted] = useState(false);
  const [isInstallationAuthorized, setIsInstallationAuthorized] = useState(false);
  const [installationGross, setInstallationGross] = useState(0);
  const [isInstallationItemCompleted, setIsInstallationItemCompleted] = useState(false);
  const [isInstallationItemInProgress, setIsInstallationItemInProgress] = useState(false);
  const [authorizationInstallationData, setAuthorizationInstallationData] = useState(null);

  // State variables for priority editing
  const [priorityEditMode, setPriorityEditMode] = useState(false);
  const [selectedPriority, setSelectedPriority] = useState(null);
  
  // State variables for comments editing
  const [commentsEditMode, setCommentsEditMode] = useState(false);
  const [editedComments, setEditedComments] = useState('');
  
  // State variables for status editing
  const [statusEditMode, setStatusEditMode] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  
  // State variables for ON HOLD REASON editing
  const [onHoldReasonEditMode, setOnHoldReasonEditMode] = useState(false);
  const [editedOnHoldReason, setEditedOnHoldReason] = useState('');

  const [maxAuthorizeValue, setMaxAuthorizeValue] = useState(0);


  const CustomPaperClip = ({ color, onClick }) => (
    <span role="img" aria-label="paper-clip" className="anticon anticon-paper-clip" style={{ color: color, cursor: onClick ? 'pointer' : 'default' }} onClick={onClick}>
      <svg 
        viewBox="64 64 896 896" 
        focusable="false" 
        data-icon="paper-clip" 
        width="1.5em" 
        height="1.5em" 
        fill={color} 
        style={{ color: color }}
        aria-hidden="true"
      >
        <path 
          d="M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0012.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 00174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z"
          fill={color}
          style={{ fill: color }}
        ></path>
      </svg>
    </span>
  );
  
  // Helper function to check if the project is on hold
  const isProjectOnHold = () => {
    return (formValues.status === 'On Hold' || record.status === 'On Hold' || selectedStatus === 'On Hold');
  };

  // Helper function to check if authorization is needed for excess quantity
  const needsAuthorization = (inputQty, expectedQty, maxAuthorizeValue, isAuthorized) => {
    const numInputQty = Number(inputQty);
    const numExpectedQty = Number(expectedQty || 1);
    const numMaxAuthorizeValue = Number(maxAuthorizeValue);
    
    // If no excess quantity, no authorization needed
    if (!(numInputQty > numExpectedQty)) {
      return false;
    }
    
    // If already authorized, no authorization needed
    if (isAuthorized) {
      return false;
    }
    
    // If maxAuthorizeValue is set and input quantity is within authorized limit
    if (numMaxAuthorizeValue > 0 && numInputQty <= numMaxAuthorizeValue) {
      return false;
    }
    
    // Authorization is needed
    return true;
  };
  
  // State variable for dynamic fields edit mode
  const [dynamicFieldsEditMode, setDynamicFieldsEditMode] = useState(false);
  const [dynamicFieldValues, setDynamicFieldValues] = useState({});
  const isInitialMount = useRef(true);

  const { user: currentUser } = useSelector((state) => state.authReducer || {});

  // Clear saving state after data refresh (when record changes after initial mount)
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    setIsSaving(false);
  }, [record?.id]);
  
  // Helper function to refresh data after save operations
  const refreshData = () => {
    if (refetchParams) {
      dispatch(fetchMaterialControl({
        page: refetchParams.page,
        perPage: (refetchParams.perPage ?? refetchParams.per_page ?? 10),
        search: refetchParams.search,
        orderBy: refetchParams.sort,
        orderDirection: refetchParams.order,
        projectId: project_id
      }));
    }
  };

  // Helper function to disable future dates in DatePicker
  const disabledDate = (current) => {
    // Disable dates after today
    return current && current > moment().endOf('day');
  };

  // Helper function to upload local signed delivery note attachments to API
  const uploadLocalSignedDeliveryNoteAttachments = async (progressStepId) => {
    if (localSignedDeliveryNoteAttachments.length === 0) {
      return;
    }

    try {
      for (const attachment of localSignedDeliveryNoteAttachments) {
        if (attachment.isLocal && attachment.file) {
          const formData = new FormData();
          formData.append('attachableType', 'ProgressStep');
          formData.append('attachableId', progressStepId);
          formData.append('documents', attachment.file);
          formData.append('additionalData', JSON.stringify({ signedDeliveryNote: true }));

          await axios({
            method: 'POST',
            url: `${baseURL}/attachments`,
            data: formData,
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }
      }
      
      // Clear local attachments after successful upload
      setLocalSignedDeliveryNoteAttachments([]);
      message.success('Signed delivery note attachments uploaded successfully');
      
    } catch (error) {
      console.error('Error uploading signed delivery note attachments:', error);
      message.error('Failed to upload some signed delivery note attachments');
    }
  };
  
  const handleSaveMarkRecieved = (type = 'fabrication', authReason = null) => {
    setIsSaving(true);
    // Determine which state variables to use based on type
    let selectedDateValue, receivedQtyValue, selectedLocationValue;
    let setDatePickerVisibleFunc, setQtyInputVisibleFunc, setDateIsSavedFunc, setQtyIsSavedFunc, setUpdatedByUserFunc, setIsItemReceivedFunc, setStatusBadgeFunc;
    let successMessage;
    let progressStepsId;
    
    // Set current date using moment
    const currentDate = moment();

    switch(type) {
      case 'fabrication':
        selectedDateValue = selectedDate;
        receivedQtyValue = receivedQty;
        selectedLocationValue = selectedLocation;
        setDatePickerVisibleFunc = setDatePickerVisible;
        setQtyInputVisibleFunc = setQtyInputVisible;
        setDateIsSavedFunc = setDateIsSaved;
        setQtyIsSavedFunc = setQtyIsSaved;
        setUpdatedByUserFunc = setUpdatedByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsItemReceived;
        successMessage = 'Item marked as received for Fabrication';
        break;
      case 'qc_release':
        selectedDateValue = selectedQcDate;
        receivedQtyValue = qcQty;
        selectedLocationValue = selectedQcLocation;
        setDatePickerVisibleFunc = setQcDatePickerVisible;
        setQtyInputVisibleFunc = setQcQtyInputVisible;
        setDateIsSavedFunc = setQcDateIsSaved;
        setQtyIsSavedFunc = setQcQtyIsSaved;
        setUpdatedByUserFunc = setQcByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsQcCompleted;
        successMessage = 'Item marked as received for QC Release';
        break;
      case 'corrosion_protection':
        selectedDateValue = selectedCorrosionDate;
        receivedQtyValue = corrosionQty;
        selectedLocationValue = selectedCorrosionLocation;
        setDatePickerVisibleFunc = setCorrosionDatePickerVisible;
        setQtyInputVisibleFunc = setCorrosionQtyInputVisible;
        setDateIsSavedFunc = setCorrosionDateIsSaved;
        setQtyIsSavedFunc = setCorrosionQtyIsSaved;
        setUpdatedByUserFunc = setCorrosionByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsCorrosionCompleted;
        successMessage = 'Item marked as received for Corrosion Protection';
        break;
      case 'delivery_to_site':
        selectedDateValue = selectedDeliveryDate;
        receivedQtyValue = deliveryQty;
        selectedLocationValue = selectedDeliveryLocation;
        setDatePickerVisibleFunc = setDeliveryDatePickerVisible;
        setQtyInputVisibleFunc = setDeliveryQtyInputVisible;
        setDateIsSavedFunc = setDeliveryDateIsSaved;
        setQtyIsSavedFunc = setDeliveryQtyIsSaved;
        setUpdatedByUserFunc = setDeliveryByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsDeliveryCompleted;
        successMessage = 'Item marked as received for Delivery to Site';
        break;
      case 'site_receipt':
        selectedDateValue = selectedSiteReceiptDate;
        receivedQtyValue = siteReceiptQty;
        selectedLocationValue = selectedSiteReceiptLocation;
        setDatePickerVisibleFunc = setSiteReceiptDatePickerVisible;
        setQtyInputVisibleFunc = setSiteReceiptQtyInputVisible;
        setDateIsSavedFunc = setSiteReceiptDateIsSaved;
        setQtyIsSavedFunc = setSiteReceiptQtyIsSaved;
        setUpdatedByUserFunc = setSiteReceiptByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsSiteReceiptCompleted;
        successMessage = 'Item marked as received for Site Receipt';
        break;
      default:
        selectedDateValue = selectedDate;
        receivedQtyValue = receivedQty;
        selectedLocationValue = selectedLocation;
        setDatePickerVisibleFunc = setDatePickerVisible;
        setQtyInputVisibleFunc = setQtyInputVisible;
        setDateIsSavedFunc = setDateIsSaved;
        setQtyIsSavedFunc = setQtyIsSaved;
        setUpdatedByUserFunc = setUpdatedByUser;
        setStatusBadgeFunc = setStatusBadge;
        setIsItemReceivedFunc = setIsItemReceived;
    }
    
    if (!selectedDateValue) {
      message.error('Please select a date before saving');
      return;
    }
    
    if (!receivedQtyValue || isNaN(receivedQtyValue)) {
      message.error('Please enter a valid quantity');
      return;
    }
    
    if (!selectedLocationValue) {
      message.error('Please select a location');
      return;
    }
    
    // Validate attachments for corrosion protection workflow
    const hasCorrosionAttachments = localSignedDeliveryNoteAttachments && localSignedDeliveryNoteAttachments.length > 0;
    const hasCorrosionRecordAttachments = corrisonSignedDeliveryNote;
    if (type === 'corrosion_protection' && !hasCorrosionAttachments && !hasCorrosionRecordAttachments) {
      message.error('Please upload at least one signed delivery note attachment for corrosion protection');
      return;
    }
    
    // Validate attachments for delivery to site workflow
    const hasDeliveryAttachments = localSignedDeliveryNoteAttachments && localSignedDeliveryNoteAttachments.length > 0;
    const hasDeliveryRecordAttachments = deliveryToSiteSignedDeliveryNote;
    if (type === 'delivery_to_site' && !hasDeliveryAttachments && !hasDeliveryRecordAttachments) {
      message.error('Please upload at least one signed delivery note attachment for delivery to site');
      return;
    }
    
    // Validate attachments for site receipt workflow
    const hasSiteReceiptAttachments = localSignedDeliveryNoteAttachments && localSignedDeliveryNoteAttachments.length > 0;
    const hasSiteReceiptRecordAttachments = siteReceiptSignedDeliveryNote;
    if (type === 'site_receipt' && !hasSiteReceiptAttachments && !hasSiteReceiptRecordAttachments) {
      message.error('Please upload at least one signed delivery note attachment for site receipt');
      return;
    }
    
    setDatePickerVisibleFunc(false);
    setQtyInputVisibleFunc(false);
    setDateIsSavedFunc(true);
    setQtyIsSavedFunc(true);
    
    if (currentUser && currentUser.firstName && currentUser.lastName) {
      setUpdatedByUserFunc(`${currentUser.firstName} ${currentUser.lastName}`);
    }

    if (type === 'fabrication' && isItemReceived) {
      progressStepsId = fabrication.id;
    }

    if (type === 'qc_release' && (qcDateIsSaved && !qcCompletedDatePickerVisible)) {
      progressStepsId = qcRelease.id;
    }

    if (type === 'corrosion_protection' && (corrosionDateIsSaved && !corrosionCompletedDatePickerVisible)) {
      progressStepsId = corrosionProtection.id;
    }

    if (type === 'delivery_to_site' && (deliveryDateIsSaved && !deliveryCompletedDatePickerVisible)) {
      progressStepsId = deliveryToSite.id;
    }

    if (type === 'site_receipt' && (siteReceiptDateIsSaved && !siteReceiptCompletedDatePickerVisible)) {
      progressStepsId = siteReceipt.id;
    }
    
    const createMarkReceivedData = {
      receivedAt: selectedDateValue.format('YYYY-MM-DD'),
      receivedQty: Number(receivedQtyValue),
      receivedLocationId: selectedLocationValue,
      receivedById: currentUser?.id,
      createdById: currentUser?.id,
      status: 'received',
      materialControlRegisterId: record?.id, // ID of the current record being marked as received
      projectId: project_id, // Project ID from props
      type: type // Add the type to identify which tracking stage this is for
    };

    // Add local attachments based on workflow type
    if (type === 'corrosion_protection' && localSignedDeliveryNoteAttachments.length > 0) {
      createMarkReceivedData.attachments = localSignedDeliveryNoteAttachments.map(attachment => ({
        file: attachment.file,
        filename: attachment.filename,
        originalName: attachment.originalName,
        additionalData: { signedDeliveryNote: true }
      }));
    }
    
    // Add attachments for delivery to site
    if (type === 'delivery_to_site' && localSignedDeliveryNoteAttachments.length > 0) {
      createMarkReceivedData.attachments = localSignedDeliveryNoteAttachments.map(attachment => ({
        file: attachment.file,
        filename: attachment.filename,
        originalName: attachment.originalName,
        additionalData: { signedDeliveryNote: true }
      }));
    }
    
    // Add attachments for site receipt
    if (type === 'site_receipt' && localSignedDeliveryNoteAttachments.length > 0) {
      createMarkReceivedData.attachments = localSignedDeliveryNoteAttachments.map(attachment => ({
        file: attachment.file,
        filename: attachment.filename,
        originalName: attachment.originalName,
        additionalData: { signedDeliveryNote: true }
      }));
    }

    const updateMarkReceivedData = {
      receivedAt: selectedDateValue.format('YYYY-MM-DD'),
      receivedQty: Number(receivedQtyValue),
      receivedLocationId: selectedLocationValue,
      receivedById: currentUser?.id,
      createdById: currentUser?.id,
      materialControlRegisterId: record?.id,
      progressStepId: progressStepsId,
    };

    // Handle authorization data with proper null checks
    const authorizeData = {
      receivedAuthorizedById: currentUser?.id,
      receivedAuthorizedAt: currentDate.format('YYYY-MM-DD HH:mm:ss'),
      receivedAuthorizedReason: authReason ? (typeof authReason === 'object' ? authReason.receivedAuthorizedReason || '' : authReason) : '',
      materialControlRegisterId: record?.id,
      progressStepId: progressStepsId,
    };
    
    if (isItemReceived && type === 'fabrication' || 
      (qcDateIsSaved && !qcCompletedDatePickerVisible) && type === 'qc_release' || 
      (corrosionDateIsSaved && !corrosionCompletedDatePickerVisible) && type === 'corrosion_protection' || 
      (deliveryDateIsSaved && !deliveryCompletedDatePickerVisible) && type === 'delivery_to_site' || 
      (siteReceiptDateIsSaved && !siteReceiptCompletedDatePickerVisible) && type === 'site_receipt'){
      // API call to mark item as received
      // Include authorization data if provided
      if (authReason) {
        dispatch(markItemAsReceivedUpdate({
          data: authorizeData
        }));
      } else {
        dispatch(markItemAsReceivedUpdate({
          data: updateMarkReceivedData
        }));
      }
      message.success(successMessage);
      setIsItemReceivedFunc(true);
      setStatusBadgeFunc('received');
      
      // Upload local signed delivery note attachments for corrosion protection
      if (type === 'corrosion_protection' && progressStepsId) {
        uploadLocalSignedDeliveryNoteAttachments(progressStepsId);
      }
      
      // Refresh data to sync state
      if (window.__activateQueueLoader) window.__activateQueueLoader();
      refreshData();

      }else{
      // API call to mark item as received
      dispatch(markItemAsReceived({
        data: createMarkReceivedData
      }));

      message.success(successMessage);
      setIsItemReceivedFunc(true);
      setStatusBadgeFunc('received');
      
      // Update tracking stage status
      updateTrackingStageStatus(type, 'received');
      
      // Clear local attachments after successful API call (handled by saga)
      if ((type === 'corrosion_protection' || type === 'delivery_to_site' || type === 'site_receipt') && localSignedDeliveryNoteAttachments.length > 0) {
        setLocalSignedDeliveryNoteAttachments([]);
      }
      
      // Refresh data to sync state after 3 seconds to allow saga to complete
      if (window.__activateQueueLoader) window.__activateQueueLoader();
      setTimeout(() => {
        refreshData();
      }, 2000);
    }
    
  };
  
  // Helper function to update tracking stage status based on type and status
  const updateTrackingStageStatus = (type, status) => {
    
    // Update local state
    switch(type) {
      case 'fabrication':
        setFabrication(prev => ({ ...prev, status }));
        break;
      case 'qc_release':
        setQcRelease(prev => ({ ...prev, status }));
        break;
      case 'corrosion_protection':
        setCorrosionProtection(prev => ({ ...prev, status }));
        break;
      case 'delivery_to_site':
        setDeliveryToSite(prev => ({ ...prev, status }));
        break;
      case 'site_receipt':
        setSiteReceipt(prev => ({ ...prev, status }));
        break;
      case 'installation':
        setInstallation(prev => ({ ...prev, status }));
      default:
        console.warn(`Unknown tracking stage type: ${type}`);
        return; // Don't proceed if type is unknown
    }
    
    // Notify parent component about the status update
    if (onTrackingStageStatusUpdate) {
      // Find the index of the progress step based on type
      let stepIndex;
      switch(type) {
        case 'fabrication': stepIndex = 0; break;
        case 'qc_release': stepIndex = 1; break;
        case 'corrosion_protection': stepIndex = 2; break;
        case 'delivery_to_site': stepIndex = 3; break;
        case 'site_receipt': stepIndex = 4; break;
        case 'installation': stepIndex = 5; break;
        default: stepIndex = -1;
      }
      
      if (stepIndex >= 0) {
        // Get the appropriate user-selected date based on the type and status
        let statusDate;
        
        if (status === 'received') {
          // Use the appropriate received date based on the workflow stage
          switch(type) {
            case 'fabrication':
              statusDate = selectedDate ? moment(selectedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'qc_release':
              statusDate = selectedQcDate ? moment(selectedQcDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'corrosion_protection':
              statusDate = selectedCorrosionDate ? moment(selectedCorrosionDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'delivery_to_site':
              statusDate = selectedDeliveryDate ? moment(selectedDeliveryDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'site_receipt':
              statusDate = selectedSiteReceiptDate ? moment(selectedSiteReceiptDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            default:
              statusDate = moment().format('YYYY-MM-DD');
          }
        } else if (status === 'completed' || status === 'in_progress') {
          // Use the appropriate completed date based on the workflow stage
          switch(type) {
            case 'fabrication':
              statusDate = selectedCompletedDate ? moment(selectedCompletedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'qc_release':
              statusDate = selectedQcCompletedDate ? moment(selectedQcCompletedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'corrosion_protection':
              statusDate = selectedCorrosionCompletedDate ? moment(selectedCorrosionCompletedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'delivery_to_site':
              statusDate = selectedDeliveryCompletedDate ? moment(selectedDeliveryCompletedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'site_receipt':
              statusDate = selectedSiteReceiptCompletedDate ? moment(selectedSiteReceiptCompletedDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            case 'installation':
              statusDate = selectedInstallationDate ? moment(selectedInstallationDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD');
              break;
            default:
              statusDate = moment().format('YYYY-MM-DD');
          }
        } else {
          // For other statuses, use current date as fallback
          statusDate = moment().format('YYYY-MM-DD');
        }
        
        onTrackingStageStatusUpdate({
          recordId: record.id,
          stepIndex,
          type,
          status,
          statusDate
        });
      }
    }
  };

  const handleSupplierSelection = (type, progressStep, selectedSupplierId) => {
    if (!selectedSupplierId) {
      return;
    }
    if (!progressStep?.supplierId && !progressStep?.id) {
      const markReceivedData = {
        supplierId: selectedSupplierId,
        materialControlRegisterId: record?.id,
        projectId: project_id,
        type: type
      };
      dispatch(markItemAsReceived({
        data: markReceivedData
      }));
    } else {
      const completedData = {
        supplierId: selectedSupplierId,
        materialControlRegisterId: record?.id,
        progressStepId: progressStep ? progressStep.id : null,
        type: type
      };
      dispatch(markItemAsCompleted({
        data: {
          ...completedData,
          projectId: project_id,
          refetchParams
        }
      }));
    }
  };

  const handleSaveMarkCompleted = (type = 'fabrication', authReason = null) => {
    setIsSaving(true);
    // Determine which state variables to use based on type
    let selectedCompletedDateValue, completedQtyValue, selectedCompletedLocationValue;
    let setCompletedDatePickerVisibleFunc, setCompletedQtyInputVisibleFunc;
    let setCompletedDateIsSavedFunc, setCompletedQtyIsSavedFunc;
    let setCompletedByUserFunc, setGrossCompletedFunc;
    let setIsItemCompletedFunc, setIsItemInProgressFunc;
    let setIsQCReleaseReadyFunc, setIsCorrosionProtectionReadyFunc, setIsDeliveryToSiteReadyFunc, setIsSiteReceiptReadyFunc, setIsInstallationReadyFunc;
    let successMessage = 'Item marked as completed';
    let progressStepsId;
    
    switch(type) {
      case 'fabrication':
        selectedCompletedDateValue = selectedCompletedDate;
        completedQtyValue = completedQty;
        selectedCompletedLocationValue = selectedCompletedLocation;
        setCompletedDatePickerVisibleFunc = setCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setCompletedQtyIsSaved;
        setCompletedByUserFunc = setCompletedByUser;
        setGrossCompletedFunc = setGrossCompleted;
        setIsItemCompletedFunc = setIsItemCompleted;
        setIsItemInProgressFunc = setIsItemInProgress;
        setIsQCReleaseReadyFunc = setIsQCReleaseReady;
        setIsCorrosionProtectionReadyFunc = () => {};
        successMessage = 'Item marked as completed for Fabrication';
        break;
      case 'qc_release':
        selectedCompletedDateValue = selectedQcCompletedDate;
        completedQtyValue = qcCompletedQty;
        selectedCompletedLocationValue = selectedQcCompletedLocation;
        setCompletedDatePickerVisibleFunc = setQcCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setQcCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setQcCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setQcCompletedQtyIsSaved;
        setCompletedByUserFunc = setQcCompletedByUser;
        setGrossCompletedFunc = setQcGrossCompleted;
        setIsItemCompletedFunc = setIsQcItemCompleted;
        setIsItemInProgressFunc = setIsQcItemInProgress;
        setIsQCReleaseReadyFunc = () => {};
        setIsCorrosionProtectionReadyFunc = setIsCorrosionProtectionReady;
        successMessage = 'Item marked as completed for QC Release';
        break;
      case 'corrosion_protection':
        selectedCompletedDateValue = selectedCorrosionCompletedDate;
        completedQtyValue = corrosionCompletedQty;
        selectedCompletedLocationValue = selectedCorrosionCompletedLocation;
        setCompletedDatePickerVisibleFunc = setCorrosionCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setCorrosionCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setCorrosionCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setCorrosionCompletedQtyIsSaved;
        setCompletedByUserFunc = setCorrosionCompletedByUser;
        setGrossCompletedFunc = setCorrosionGrossCompleted;
        setIsItemCompletedFunc = () => {}; // Not used for corrosion protection
        setIsItemInProgressFunc = () => {}; // Not used for corrosion protection
        setIsQCReleaseReadyFunc = () => {};
        setIsCorrosionProtectionReadyFunc = () => {}; // Not needed for corrosion protection
        setIsDeliveryToSiteReadyFunc = setIsDeliveryToSiteReady;
        successMessage = 'Item marked as completed for Corrosion Protection';
        break;
      case 'delivery_to_site':
        selectedCompletedDateValue = selectedDeliveryCompletedDate;
        completedQtyValue = deliveryCompletedQty;
        selectedCompletedLocationValue = selectedDeliveryCompletedLocation;
        setCompletedDatePickerVisibleFunc = setDeliveryCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setDeliveryCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setDeliveryCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setDeliveryCompletedQtyIsSaved;
        setCompletedByUserFunc = setDeliveryCompletedByUser;
        setGrossCompletedFunc = setDeliveryGrossCompleted;
        setIsItemCompletedFunc = setIsDeliveryItemCompleted;
        setIsItemInProgressFunc = setIsDeliveryItemInProgress;
        setIsQCReleaseReadyFunc = () => {};
        setIsCorrosionProtectionReadyFunc = () => {};
        setIsDeliveryToSiteReadyFunc = () => {};
        setIsSiteReceiptReadyFunc = setIsSiteReceiptReady;
        successMessage = 'Item marked as completed for Delivery to Site';
        progressStepsId = deliveryToSite?.id;
        break;
      case 'site_receipt':
        // Use site receipt specific state variables
        selectedCompletedDateValue = selectedSiteReceiptCompletedDate;
        completedQtyValue = siteReceiptCompletedQty;
        selectedCompletedLocationValue = selectedSiteReceiptCompletedLocation;
        setCompletedDatePickerVisibleFunc = setSiteReceiptCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setSiteReceiptCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setSiteReceiptCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setSiteReceiptCompletedQtyIsSaved;
        setCompletedByUserFunc = setSiteReceiptCompletedByUser;
        setGrossCompletedFunc = setSiteReceiptGrossCompleted;
        setIsItemCompletedFunc = setIsSiteReceiptItemCompleted;
        setIsItemInProgressFunc = setIsSiteReceiptItemInProgress;
        setIsQCReleaseReadyFunc = () => {};
        setIsCorrosionProtectionReadyFunc = () => {};
        setIsDeliveryToSiteReadyFunc = () => {};
        setIsInstallationReadyFunc = setIsInstallationReady;
        successMessage = 'Item marked as completed for Site Receipt';
        progressStepsId = siteReceipt?.id;
        console.log('siteReceipt id', progressStepsId);
        break;
      case 'installation':
        selectedCompletedDateValue = selectedInstallationDate;
        completedQtyValue = installationQty;
        selectedCompletedLocationValue = selectedInstallationLocation;
        setCompletedDatePickerVisibleFunc = setInstallationDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setInstallationQtyInputVisible;
        setCompletedDateIsSavedFunc = setInstallationDateIsSaved;
        setCompletedQtyIsSavedFunc = setInstallationQtyIsSaved;
        setCompletedByUserFunc = setInstallationByUser;
        setGrossCompletedFunc = setInstallationGross;
        setIsItemCompletedFunc = setIsInstallationItemCompleted;
        setIsItemInProgressFunc = setIsInstallationItemInProgress;
        setIsQCReleaseReadyFunc = () => { };
        setIsCorrosionProtectionReadyFunc = () => { };
        setIsDeliveryToSiteReadyFunc = () => { };
        setIsSiteReceiptReadyFunc = () => { };
        successMessage = 'Installation details updated successfully';        
        progressStepsId = installation?.id;
        break;
      default:
        selectedCompletedDateValue = selectedCompletedDate;
        completedQtyValue = completedQty;
        selectedCompletedLocationValue = selectedCompletedLocation;
        setCompletedDatePickerVisibleFunc = setCompletedDatePickerVisible;
        setCompletedQtyInputVisibleFunc = setCompletedQtyInputVisible;
        setCompletedDateIsSavedFunc = setCompletedDateIsSaved;
        setCompletedQtyIsSavedFunc = setCompletedQtyIsSaved;
        setCompletedByUserFunc = setCompletedByUser;
        setGrossCompletedFunc = setGrossCompleted;
        setIsItemCompletedFunc = setIsItemCompleted;
        setIsItemInProgressFunc = setIsItemInProgress;
        setIsQCReleaseReadyFunc = setIsQCReleaseReady;
    }
    
    if (!selectedCompletedDateValue) {
      message.error('Please select a completion date before saving');
      return;
    }
    
    if (!completedQtyValue || isNaN(completedQtyValue)) {
      message.error('Please enter a valid quantity');
      return;
    }

    // Validate that quantity is less than or equal to record.qty
    const recordQty = record.qty || 1;
    // if (Number(completedQtyValue) > recordQty) {
    //   message.error(`Completed quantity cannot exceed ${recordQty}`);
    //   return;
    // }
    
    // Validate location
    if (!selectedCompletedLocationValue) {
      message.error('Please select a location');
      return;
    }
    
    // Save all values
    setCompletedDatePickerVisibleFunc(false);
    setCompletedQtyInputVisibleFunc(false);
    setCompletedDateIsSavedFunc(true);
    setCompletedQtyIsSavedFunc(true);
    
    if (currentUser && currentUser.firstName && currentUser.lastName) {
      setCompletedByUserFunc(`${currentUser.firstName} ${currentUser.lastName}`);
    }
    if(record.totalGross){
      setGrossCompletedFunc(record.totalGross);
    }
    
    // Check if the completed quantity is greater than or equal to the record quantity
    const isFullyCompleted = Number(completedQtyValue) >= Number(recordQty);
    const isPartiallyCompleted = Number(completedQtyValue) > 0 && Number(completedQtyValue) < Number(recordQty);
    
    // Update the completed status based on quantity comparison
    setIsItemCompletedFunc(isFullyCompleted);
    setIsItemInProgressFunc(isPartiallyCompleted);
    setGrossCompletedFunc((record.unitSubtotal * Number(completedQtyValue)).toFixed(2));
    setSupplierEditMode(false);
    setQcSupplierEditMode(false);
    setCorrosionSupplierEditMode(false);
    
    // Only set QC Release ready for fabrication type
    if (type === 'fabrication') {
      setIsQCReleaseReadyFunc(true);
      progressStepsId = fabrication.id;
    }

    if (type === 'qc_release') {
      setIsCorrosionProtectionReadyFunc(true);
      progressStepsId = qcRelease.id;
    }

    if (type === 'corrosion_protection') {
      setIsDeliveryToSiteReadyFunc(true);
      progressStepsId = corrosionProtection.id;
    }

    if (type === 'site_receipt') {
      setIsInstallationReadyFunc(true);
      progressStepsId = siteReceipt.id;
    }

    if (type === 'installation') {
      progressStepsId = installation?.id;
    }

    // Prepare data for API call
    const completedData = {
      completedAt: selectedCompletedDateValue.format('YYYY-MM-DD'), // DATE COMPLETED passed as completedAt
      completedQty: Number(completedQtyValue), // QTY COMPLETED passed as completedQty
      completedLocationId: selectedCompletedLocationValue, // Location ID
      completedById: currentUser?.id, // UPDATED BY passed as createdById
      totalGross: (record.unitSubtotal * Number(completedQtyValue)).toFixed(2),
      progressStepId: progressStepsId,
      materialControlRegisterId: record?.id,
      status: isFullyCompleted ? 'completed' : (isPartiallyCompleted ? 'in_progress' : 'not_started') // status-badge passed as status
    };

    const authorizeData = {
      completedAuthorizedById: currentUser?.id,
      completedAuthorizedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
      completedAuthorizedReason: authReason ? (typeof authReason === 'object' ? authReason.receivedAuthorizedReason || '' : authReason) : '',
      materialControlRegisterId: record?.id,
      progressStepId: progressStepsId,
    };

    
    // Special handling for installation type - create step if it doesn't exist
    if (type === 'installation' && !installation?.id) {
      // Installation step doesn't exist yet, create it first using POST
      const createInstallationData = {
        completedAt: selectedCompletedDateValue.format('YYYY-MM-DD'),
        completedQty: Number(completedQtyValue),
        completedLocationId: selectedCompletedLocationValue,
        completedById: currentUser?.id,
        createdById: currentUser?.id,
        status: isFullyCompleted ? 'completed' : (isPartiallyCompleted ? 'in_progress' : 'not_started'),
        materialControlRegisterId: record?.id,
        projectId: project_id,
        type: 'installation',
        totalGross: (record.unitSubtotal * Number(completedQtyValue)).toFixed(2)
      };

      // Call markItemAsReceived to CREATE the step (POST)
      dispatch(markItemAsReceived({
        data: createInstallationData
      }));

      message.success(successMessage);

      // Update tracking stage status
      const status = isFullyCompleted ? 'completed' : (isPartiallyCompleted ? 'in_progress' : 'not_started');
      updateTrackingStageStatus(type, status);
      setIsItemCompletedFunc(isFullyCompleted);
      setIsItemInProgressFunc(isPartiallyCompleted);

      // Refresh data to sync state after 3 seconds to allow saga to complete
      if (window.__activateQueueLoader) window.__activateQueueLoader();
      setTimeout(() => {
        refreshData();
      }, 2000);
    } else {
      // Make the API call to mark item as completed
      if (authReason) {
        dispatch(markItemAsCompleted({
          data: {
            ...authorizeData,
            projectId: project_id,
            refetchParams
          }
        }));
      } else {
        dispatch(markItemAsCompleted({
          data: {
            ...completedData,
            projectId: project_id,
            refetchParams
          }
        }));
      }
      message.success(successMessage);
      setIsQCReleaseReadyFunc(true);

      // Update status badge after successful API call
      const status = isFullyCompleted ? 'completed' : (isPartiallyCompleted ? 'in_progress' : 'not_started');

      // Update tracking stage status
      updateTrackingStageStatus(type, status);
      setIsCorrosionProtectionReadyFunc(true);
      setIsItemCompletedFunc(isFullyCompleted);
      setIsItemInProgressFunc(isPartiallyCompleted);

      // Refresh data to sync state
      if (window.__activateQueueLoader) window.__activateQueueLoader();
      refreshData();
    }
  };

  const updateMaterialControlRecord = (data) => {

    dispatch(
      updateMaterialControl({
        ...data,
        id: record.id,
        project_id: project_id,
        updatedById: currentUser?.id, // Add the current user ID as the updater
        onSuccess: () => {
          // Refresh data to sync state
          refreshData();
        },
        onError: (error) => {
          console.error("Error updating material control:", error);
        }
      })
    )
  };
    

  const { projectPriorities, fetchPrioritiesLoading } = useSelector((state) => state.projectsSetupReducer || {});
  const { allSuppliers, fetchingLoading: suppliersLoading } = useSelector((state) => state.supplierTypeReducer || {});
  const { allCommodities, fetchingLoading: commoditiesLoading } = useSelector((state) => state.commodityReducer || {});
  const { allLocations, fetchLocationsLoading: locationsLoading } = useSelector((state) => state.locationsReducer || {});
  const { currentUserObj, fetchUserDetailLoading, user_projects } = useSelector((state) => state.userManagerReducer || {});
  const { newMaterialControl } = useSelector((state) => state.projectReducer || {});
  
  // State for on hold user and updated by user
  const [onHoldUser, setOnHoldUser] = useState(null);
  const [updatedBy, setUpdatedBy] = useState(null);

  useEffect(() => {
    if (currentUserObj && !fetchUserDetailLoading) {
      if (record.createdById && currentUserObj.id === record.createdById) {
        setUser(currentUserObj);
      }
      if (record.onHoldById && currentUserObj.id === record.onHoldById) {
        setOnHoldUser(currentUserObj);
      }
      if (record.updatedById && currentUserObj.id === record.updatedById) {
        setUpdatedBy(currentUserObj);
      }
    }
  }, [currentUserObj, fetchUserDetailLoading, record.createdById, record.onHoldById, record.updatedById]);
  
  useEffect(() => {
    dispatch(fetchAllLocations({
      page: 1,
      per_page: 100,
      search: {},
      show_by_default: true,
      managedProjectId: project_id,
    }));
  }, [dispatch]);
  // Handle record type normalization and user fetching
  useEffect(() => {
    if (record.type === "material") {
      record.type = "Material";
      if (record.createdById && !user) {
        dispatch(fetchUser(record.createdById));
      }
      if (record.onHoldById && !onHoldUser) {
        dispatch(fetchUser(record.onHoldById));
      }
      if (record.updatedById && !updatedBy) {
        dispatch(fetchUser(record.updatedById));
      }
    } else if (record.type === "bolts") {
      record.type = "Bolts";
      if (record.createdById && !user) {
        dispatch(fetchUser(record.createdById));
      }
      if (record.onHoldById && !onHoldUser) {
        dispatch(fetchUser(record.onHoldById));
      }
      if (record.updatedById && !updatedBy) {
        dispatch(fetchUser(record.updatedById));
      }
    }
  }, [record, user, onHoldUser, updatedBy, dispatch]);

  useEffect(() => {
    if (project_id) {
      dispatch(fetchProjectPriorities(project_id));
    }
    dispatch(fetchSuppliers({ page: 1, limit: 100, search: {} }));
    dispatch(fetchCommodities({ page: 1, limit: 100, search: {} }));
  }, [dispatch, project_id]);

  // Initialize formValues with record data
  useEffect(() => {
    // Initialize strictly from the record prop to avoid Redux slice leakage
    const currentRecord = record;
    
    if (currentRecord) {
      setFormValues(prev => ({ ...prev, ...currentRecord }));
      
      // Initialize supplier for tracking with the appropriate supplierId based on section
      // Note: For Fabrication section, we don't use record.supplierId
      // For other sections, we can still use record.supplierId if needed
      
      // Set projectStages and individual tracking stages from progressSteps if it exists
      if (currentRecord.progressSteps) {
        setProjectStages(currentRecord.progressSteps);
        
        // Set fabrication which is progressSteps[0]
        if (currentRecord.progressSteps[0]) {
          setFabrication(currentRecord.progressSteps[0]);
          setIsItemReceived(currentRecord.progressSteps[0].status === 'received' || false);
          setIsItemCompleted(currentRecord.progressSteps[0].status === 'completed' || false);
          setIsItemInProgress(currentRecord.progressSteps[0].status === 'in_progress' || false);


          if (currentRecord.progressSteps[0].status) {
            setStatusBadge(currentRecord.progressSteps[0].status);
          }
          
          // Initialize the supplier ID from fabrication data
          if (currentRecord.progressSteps[0].supplierId) {
            setSelectedSupplierForTracking(currentRecord.progressSteps[0].supplierId);
          }
          
          // Add these lines to initialize the date, qty, and location from fabrication data
          if (currentRecord.progressSteps[0].receivedAt) {
            setIsItemReceived(true);
            setSelectedDate(moment(currentRecord.progressSteps[0].receivedAt));
            setDateIsSaved(true);
          }
          
          if (currentRecord.progressSteps[0].receivedQty) {
            setReceivedQty(currentRecord.progressSteps[0].receivedQty);
            setQtyIsSaved(true);
          }
          
          if (currentRecord.progressSteps[0].receivedLocationId) {
            setSelectedLocation(currentRecord.progressSteps[0].receivedLocationId);
          }
          
          // Set the updated by user from fabrication.createdBy if available
          if (currentRecord.progressSteps[0].receivedBy && 
              currentRecord.progressSteps[0].receivedBy.firstName && 
              currentRecord.progressSteps[0].receivedBy.lastName) {
            setUpdatedByUser(`${currentRecord.progressSteps[0].receivedBy.firstName} ${currentRecord.progressSteps[0].receivedBy.lastName}`);
          }

          if (currentRecord.progressSteps[0].receivedAuthorizedAt) {
            setMaxAuthorizeValue(currentRecord.progressSteps[0].receivedQty);
            setIsAuthorized(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[0].receivedAuthorizedBy ? 
                `${currentRecord.progressSteps[0].receivedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[0].receivedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[0].receivedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[0].receivedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationReceivedData(authData);
          }

          if (currentRecord.progressSteps[0].completedAuthorizedAt) {
            setIsCompletedAuthorized(true);
            if (currentRecord.progressSteps[0].completedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[0].completedQty);
            }
          }
          
          if (currentRecord.progressSteps[0].completedAt) {
            setSelectedCompletedDate(moment(currentRecord.progressSteps[0].completedAt));
            setCompletedDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[0].completedAuthorizedBy ? 
                `${currentRecord.progressSteps[0].completedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[0].completedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[0].completedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[0].completedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationCompletedData(authData);
          }
          
          if (currentRecord.progressSteps[0].completedQty) {
            setCompletedQty(currentRecord.progressSteps[0].completedQty);
            setCompletedQtyIsSaved(true);
          }
          
          if (currentRecord.progressSteps[0].completedLocationId) {
            setSelectedCompletedLocation(currentRecord.progressSteps[0].completedLocationId);
          }

          if (currentRecord.progressSteps[0].completedBy && 
              currentRecord.progressSteps[0].completedBy.firstName && 
              currentRecord.progressSteps[0].completedBy.lastName) {
            setCompletedByUser(`${currentRecord.progressSteps[0].completedBy.firstName} ${currentRecord.progressSteps[0].completedBy.lastName}`);
          }

          if (currentRecord.progressSteps[0].totalGross) {
            setGrossCompleted(currentRecord.progressSteps[0].totalGross);
            setIsQCReleaseReady(true);
          }
        }
        
        // Set QC release which is progressSteps[1]
        if (currentRecord.progressSteps[1]) {
          setQcRelease(currentRecord.progressSteps[1]);
          setIsQCReleaseReady(currentRecord.progressSteps[1].status === 'received' || false);

          if (currentRecord.progressSteps[1].receivedAt) {
            setSelectedQcDate(moment(currentRecord.progressSteps[1].receivedAt));
            setQcDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[1].receivedAuthorizedBy ? 
                `${currentRecord.progressSteps[1].receivedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[1].receivedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[1].receivedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[1].receivedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationQcReceivedData(authData);
          }
          
          if (currentRecord.progressSteps[1].receivedQty) {
            setQcQty(currentRecord.progressSteps[1].receivedQty);
            setQcQtyIsSaved(true);
          }
          
          if (currentRecord.progressSteps[1].receivedLocationId) {
            setSelectedQcLocation(currentRecord.progressSteps[1].receivedLocationId);
          }
          
          if (currentRecord.progressSteps[1].receivedBy && 
              currentRecord.progressSteps[1].receivedBy.firstName && 
              currentRecord.progressSteps[1].receivedBy.lastName) {
            setQcByUser(`${currentRecord.progressSteps[1].receivedBy.firstName} ${currentRecord.progressSteps[1].receivedBy.lastName}`);
          }

          if (currentRecord.progressSteps[1].completedAt) {
            setSelectedQcCompletedDate(moment(currentRecord.progressSteps[1].completedAt));
            setQcCompletedDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[1].completedAuthorizedBy ? 
                `${currentRecord.progressSteps[1].completedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[1].completedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[1].completedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[1].completedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationQcCompletedData(authData);
          }
          
          if (currentRecord.progressSteps[1].completedQty) {
            setQcCompletedQty(currentRecord.progressSteps[1].completedQty);
            setQcCompletedQtyIsSaved(true);
          }

          // Set QC Release authorization status
          if (currentRecord.progressSteps[1].receivedAuthorizedAt) {
            setIsQcAuthorized(true);
            if (currentRecord.progressSteps[1].receivedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[1].receivedQty);
            }
          }
          
          if (currentRecord.progressSteps[1].completedAuthorizedAt) {
            setIsQcCompletedAuthorized(true);
            if (currentRecord.progressSteps[1].completedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[1].completedQty);
            }
          }
          
          if (currentRecord.progressSteps[1].completedLocationId) {
            setSelectedQcCompletedLocation(currentRecord.progressSteps[1].completedLocationId);
          }
          
          if (currentRecord.progressSteps[1].completedBy && 
              currentRecord.progressSteps[1].completedBy.firstName && 
              currentRecord.progressSteps[1].completedBy.lastName) {
            setQcCompletedByUser(`${currentRecord.progressSteps[1].completedBy.firstName} ${currentRecord.progressSteps[1].completedBy.lastName}`);
          }

          if (currentRecord.progressSteps[1].totalGross) {
            setQcGrossCompleted(currentRecord.progressSteps[1].totalGross);
            setIsCorrosionProtectionReady(true);
          }

          if (currentRecord.progressSteps[1].supplierId) {
            setSelectedQcSupplierForTracking(currentRecord.progressSteps[1].supplierId);
          }
        }

        // Set corrosion protection which is progressSteps[2]
        if (currentRecord.progressSteps[2]) {
          setCorrosionProtection(currentRecord.progressSteps[2]);

          if (currentRecord.progressSteps[2].receivedAt) {
            setSelectedCorrosionDate(moment(currentRecord.progressSteps[2].receivedAt));
            setCorrosionDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[2].receivedAuthorizedBy ? 
                `${currentRecord.progressSteps[2].receivedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[2].receivedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[2].receivedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[2].receivedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationCorrosionReceivedData(authData);
          }

          if (currentRecord.progressSteps[2].receivedQty) {
            setCorrosionQty(currentRecord.progressSteps[2].receivedQty);
            setCorrosionQtyIsSaved(true);
          }

          if (currentRecord.progressSteps[2].receivedLocationId) {
            setSelectedCorrosionLocation(currentRecord.progressSteps[2].receivedLocationId);
          }

          if (currentRecord.progressSteps[2].receivedBy && 
              currentRecord.progressSteps[2].receivedBy.firstName && 
              currentRecord.progressSteps[2].receivedBy.lastName) {
            setCorrosionByUser(`${currentRecord.progressSteps[2].receivedBy.firstName} ${currentRecord.progressSteps[2].receivedBy.lastName}`);
          }

          // Set Corrosion Protection authorization status
          if (currentRecord.progressSteps[2].receivedAuthorizedAt) {
            setIsCorrosionAuthorized(true);
            if (currentRecord.progressSteps[2].receivedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[2].receivedQty);
            }
          }
          
          if (currentRecord.progressSteps[2].completedAt) {
            setSelectedCorrosionCompletedDate(moment(currentRecord.progressSteps[2].completedAt));
            setCorrosionCompletedDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[2].completedAuthorizedBy ? 
                `${currentRecord.progressSteps[2].completedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[2].completedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[2].completedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[2].completedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationCorrosionCompletedData(authData);
          }

          if (currentRecord.progressSteps[2].completedQty) {
            setCorrosionCompletedQty(currentRecord.progressSteps[2].completedQty);
            setCorrosionCompletedQtyIsSaved(true);
          }

          if (currentRecord.progressSteps[2].completedAuthorizedAt) {
            setIsCorrosionCompletedAuthorized(true);
            if (currentRecord.progressSteps[2].completedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[2].completedQty);
            }
          }

          if (currentRecord.progressSteps[2].completedLocationId) {
            setSelectedCorrosionCompletedLocation(currentRecord.progressSteps[2].completedLocationId);
          }

          if (currentRecord.progressSteps[2].completedBy && 
              currentRecord.progressSteps[2].completedBy.firstName && 
              currentRecord.progressSteps[2].completedBy.lastName) {
            setCorrosionCompletedByUser(`${currentRecord.progressSteps[2].completedBy.firstName} ${currentRecord.progressSteps[2].completedBy.lastName}`);
          }

          if (currentRecord.progressSteps[2].totalGross) {
            setCorrosionGrossCompleted(currentRecord.progressSteps[2].totalGross);
            setIsDeliveryToSiteReady(true);
          }

          if (currentRecord.progressSteps[2].supplierId) {
            setSelectedCorrosionSupplierForTracking(currentRecord.progressSteps[2].supplierId);
          }
        }

        // Set delivery to site which is progressSteps[3]
        if (currentRecord.progressSteps[3]) {
          setDeliveryToSite(currentRecord.progressSteps[3]);
          setIsDeliveryCompleted(currentRecord.progressSteps[3].status === 'received' || false);
          setIsDeliveryItemCompleted(currentRecord.progressSteps[3].status === 'completed' || false);
          setIsDeliveryItemInProgress(currentRecord.progressSteps[3].status === 'in_progress' || false);
          
          // Initialize delivery to site received data
          if (currentRecord.progressSteps[3].receivedAt) {
            setSelectedDeliveryDate(moment(currentRecord.progressSteps[3].receivedAt));
            setDeliveryDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[3].receivedAuthorizedBy ? 
                `${currentRecord.progressSteps[3].receivedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[3].receivedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[3].receivedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[3].receivedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationDeliveryReceivedData(authData);
          }
          
          if (currentRecord.progressSteps[3].receivedQty) {
            setDeliveryQty(currentRecord.progressSteps[3].receivedQty);
            setDeliveryQtyIsSaved(true);
          }
          
          if (currentRecord.progressSteps[3].receivedLocationId) {
            setSelectedDeliveryLocation(currentRecord.progressSteps[3].receivedLocationId);
          }
          
          if (currentRecord.progressSteps[3].receivedBy && 
              currentRecord.progressSteps[3].receivedBy.firstName && 
              currentRecord.progressSteps[3].receivedBy.lastName) {
            setDeliveryByUser(`${currentRecord.progressSteps[3].receivedBy.firstName} ${currentRecord.progressSteps[3].receivedBy.lastName}`);
          }

          // Set Delivery to Site authorization status
          if (currentRecord.progressSteps[3].receivedAuthorizedAt) {
            setIsDeliveryAuthorized(true);
            if (currentRecord.progressSteps[3].receivedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[3].receivedQty);
            }
          }
          
          // Initialize delivery to site completed data
          if (currentRecord.progressSteps[3].completedAt) {
            setSelectedDeliveryCompletedDate(moment(currentRecord.progressSteps[3].completedAt));
            setDeliveryCompletedDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[3].completedAuthorizedBy ? 
                `${currentRecord.progressSteps[3].completedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[3].completedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[3].completedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[3].completedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationDeliveryCompletedData(authData);
          }
          
          if (currentRecord.progressSteps[3].completedQty) {
            setDeliveryCompletedQty(currentRecord.progressSteps[3].completedQty);
            setDeliveryCompletedQtyIsSaved(true);
          }

          if (currentRecord.progressSteps[3].completedAuthorizedAt) {
            setIsDeliveryCompletedAuthorized(true);
            if (currentRecord.progressSteps[3].completedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[3].completedQty);
            }
          }
          
          if (currentRecord.progressSteps[3].completedLocationId) {
            setSelectedDeliveryCompletedLocation(currentRecord.progressSteps[3].completedLocationId);
          }
          
          if (currentRecord.progressSteps[3].completedBy && 
              currentRecord.progressSteps[3].completedBy.firstName && 
              currentRecord.progressSteps[3].completedBy.lastName) {
            setDeliveryCompletedByUser(`${currentRecord.progressSteps[3].completedBy.firstName} ${currentRecord.progressSteps[3].completedBy.lastName}`);
          }
          
          if (currentRecord.progressSteps[3].totalGross) {
            setDeliveryGrossCompleted(currentRecord.progressSteps[3].totalGross);
            setIsSiteReceiptReady(true);
          }

          if (currentRecord.progressSteps[3].supplierId) {
            setSelectedDeliverySupplierForTracking(currentRecord.progressSteps[3].supplierId);
          }
        }

        // Set site receipt which is progressSteps[4]
        if (currentRecord.progressSteps[4]) {
          setSiteReceipt(currentRecord.progressSteps[4]);
          setIsSiteReceiptCompleted(currentRecord.progressSteps[4].status === 'received' || false);
          setIsSiteReceiptItemCompleted(currentRecord.progressSteps[4].status === 'completed' || false);
          setIsSiteReceiptItemInProgress(currentRecord.progressSteps[4].status === 'in_progress' || false);
          
          // Initialize site receipt received data
          if (currentRecord.progressSteps[4].receivedAt) {
            setSelectedSiteReceiptDate(moment(currentRecord.progressSteps[4].receivedAt));
            setSiteReceiptDateIsSaved(true);
          }
          
          if (currentRecord.progressSteps[4].receivedQty) {
            setSiteReceiptQty(currentRecord.progressSteps[4].receivedQty);
            setSiteReceiptQtyIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[4].receivedAuthorizedBy ? 
                `${currentRecord.progressSteps[4].receivedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[4].receivedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[4].receivedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[4].receivedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationDeliverytoSiteReceivedData(authData);
          }
          
          // Set Site Receipt authorization status
          if (currentRecord.progressSteps[4].receivedAuthorizedAt) {
            setIsSiteReceiptAuthorized(true);
            if (currentRecord.progressSteps[4].receivedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[4].receivedQty);
            }
          }
          
          if (currentRecord.progressSteps[4].receivedLocationId) {
            setSelectedSiteReceiptLocation(currentRecord.progressSteps[4].receivedLocationId);
          }
          
          if (currentRecord.progressSteps[4].receivedBy && 
              currentRecord.progressSteps[4].receivedBy.firstName && 
              currentRecord.progressSteps[4].receivedBy.lastName) {
            setSiteReceiptByUser(`${currentRecord.progressSteps[4].receivedBy.firstName} ${currentRecord.progressSteps[4].receivedBy.lastName}`);
          }
          
          // Initialize site receipt completed data
          if (currentRecord.progressSteps[4].completedAt) {
            setSelectedSiteReceiptCompletedDate(moment(currentRecord.progressSteps[4].completedAt));
            setSiteReceiptCompletedDateIsSaved(true);
            const authData = {
              authorizedByName: currentRecord.progressSteps[4].completedAuthorizedBy ? 
                `${currentRecord.progressSteps[4].completedAuthorizedBy.firstName || ''} ${currentRecord.progressSteps[4].completedAuthorizedBy.lastName || ''}`.trim() : 
                'Unknown User',
              authorizedAt: currentRecord.progressSteps[4].completedAuthorizedAt,
              authorizedReason: currentRecord.progressSteps[4].completedAuthorizedReason || 'No reason provided'
            };
            setAuthorizationDeliverytoSiteCompletedData(authData);
          }
          
          if (currentRecord.progressSteps[4].completedQty) {
            setSiteReceiptCompletedQty(currentRecord.progressSteps[4].completedQty);
            setSiteReceiptCompletedQtyIsSaved(true);
          }

          if (currentRecord.progressSteps[4].completedAuthorizedAt) {
            setIsSiteReceiptCompletedAuthorized(true);
            if (currentRecord.progressSteps[4].completedQty > maxAuthorizeValue) {
              setMaxAuthorizeValue(currentRecord.progressSteps[4].completedQty);
            }
          }
          
          if (currentRecord.progressSteps[4].completedLocationId) {
            setSelectedSiteReceiptCompletedLocation(currentRecord.progressSteps[4].completedLocationId);
          }
          
          if (currentRecord.progressSteps[4].completedBy && 
              currentRecord.progressSteps[4].completedBy.firstName && 
              currentRecord.progressSteps[4].completedBy.lastName) {
            setSiteReceiptCompletedByUser(`${currentRecord.progressSteps[4].completedBy.firstName} ${currentRecord.progressSteps[4].completedBy.lastName}`);
          }
          
          if (currentRecord.progressSteps[4].totalGross) {
            setSiteReceiptGrossCompleted(currentRecord.progressSteps[4].totalGross);
            setIsInstallationReady(true);
          }
          
          if (currentRecord.progressSteps[4].supplierId) {
            setSelectedSiteReceiptSupplierForTracking(currentRecord.progressSteps[4].supplierId);
          }

          // installation is the 6th step
          if (currentRecord.progressSteps[5]) {
            setInstallation(currentRecord.progressSteps[5]);

            // Set completion status
            setIsInstallationCompleted(currentRecord.progressSteps[5].status === 'completed' || false);
            setIsInstallationItemInProgress(currentRecord.progressSteps[5].status === 'in_progress' || false);

            // Initialize installation completed data if it exists
            if (currentRecord.progressSteps[5].completedAt) {
              setSelectedInstallationDate(moment(currentRecord.progressSteps[5].completedAt));
              setInstallationDateIsSaved(true);
            }

            if (currentRecord.progressSteps[5].completedQty) {
              setInstallationQty(currentRecord.progressSteps[5].completedQty.toString());
              setInstallationQtyIsSaved(true);
            }

            if (currentRecord.progressSteps[5].completedLocationId) {
              setSelectedInstallationLocation(currentRecord.progressSteps[5].completedLocationId);
            }

            if (currentRecord.progressSteps[5].completedBy) {
              setInstallationByUser(
                currentRecord.progressSteps[5].completedBy.firstName &&
                  currentRecord.progressSteps[5].completedBy.lastName
                  ? `${currentRecord.progressSteps[5].completedBy.firstName} ${currentRecord.progressSteps[5].completedBy.lastName}`
                  : currentRecord.progressSteps[5].completedBy || ''
              );
            }

            if (currentRecord.progressSteps[5].totalGross) {
              setInstallationGross(currentRecord.progressSteps[5].totalGross);
            }

            // Set authorization status if needed
            if (currentRecord.progressSteps[5].completedAuthorizedById) {
              setIsInstallationAuthorized(true);

              const authUser = currentRecord.progressSteps[5].completedAuthorizedBy;
              const authUserName = authUser && authUser.firstName && authUser.lastName
                ? `${authUser.firstName} ${authUser.lastName}`
                : (authUser || 'Unknown User');

              setAuthorizationInstallationData({
                authorizedById: currentRecord.progressSteps[5].completedAuthorizedById,
                authorizedAt: currentRecord.progressSteps[5].completedAuthorizedAt,
                authorizedReason: currentRecord.progressSteps[5].completedAuthorizedReason,
                authorizedByName: authUserName
              });
            }
          }
        }
      }
    }
  }, [record?.id]);

  // Check for signed delivery note attachments when record changes
  useEffect(() => {
    if (record?.progressSteps) {
      // Check corrosion protection step for signed delivery note attachments
      const corrosionStep = record.progressSteps.find(step => step.type === 'corrosion_protection');
      if (corrosionStep?.attachments) {
        const signedDeliveryNoteAttachments = corrosionStep.attachments.filter(attachment => 
          attachment.additionalData?.signedDeliveryNote === true
        );
        setCorrisonSignedDeliveryNote(signedDeliveryNoteAttachments.length > 0);
      } else {
        setCorrisonSignedDeliveryNote(false);
      }

      // Check delivery to site step for signed delivery note attachments
      const deliveryToSiteStep = record.progressSteps.find(step => step.type === 'delivery_to_site');
      if (deliveryToSiteStep?.attachments) {
        const signedDeliveryNoteAttachments = deliveryToSiteStep.attachments.filter(attachment => 
          attachment.additionalData?.signedDeliveryNote === true
        );
        setDeliveryToSiteSignedDeliveryNote(signedDeliveryNoteAttachments.length > 0);
      } else {
        setDeliveryToSiteSignedDeliveryNote(false);
      }

      const siteReceiptStep = record.progressSteps.find(step => step.type === 'site_receipt');
      if (siteReceiptStep?.attachments) {
        const signedDeliveryNoteAttachments = siteReceiptStep.attachments.filter(attachment => 
          attachment.additionalData?.signedDeliveryNote === true
        );
        setSiteReceiptSignedDeliveryNote(signedDeliveryNoteAttachments.length > 0);
      } else {
        setSiteReceiptSignedDeliveryNote(false);
      }
    }
  }, [record]);

  // Update formValues when form is initialized or values change
  useEffect(() => {
    if (formRef && formRef.current) {
      // Get initial values
      const currentValues = formRef.current.getFieldsValue();
      setFormValues(prev => ({ ...prev, ...currentValues }));
    }
  }, [formRef]);
  
  // Handle form values change
  const handleValuesChange = (changedValues, allValues) => {
    setFormValues(prev => ({ ...prev, ...changedValues }));
  };
  // Function to render view-only content for fields
  const renderViewItem = (field, value) => {
    const { id, name, field_type, field_options } = field;
    
    // Format the value based on field type
    let displayValue = value;
    
    switch (field_type) {
      case "select_field":
        // For select fields, find the option name that matches the value
        if (field_options && Array.isArray(field_options)) {
          const option = field_options.find(opt => opt.id === value || opt.value === value);
          displayValue = option ? option.name : value;
        }
        break;
      case "date_field":
        // Format date values
        if (value) {
          try {
            const date = new Date(value);
            displayValue = date.toLocaleDateString();
          } catch (e) {
            // If date parsing fails, use the original value
          }
        }
        break;
      default:
        // Use the value as is for other field types
        break;
    }
    
    // Return a div with the field name and value
    return (
      <div className="view-field-container">
        <div className="view-field-label">{name}</div>
        <div className="view-field-value">{displayValue || '-'}</div>
      </div>
    );
  };
  
  // Function to handle form initialization
  useEffect(() => {
    // When switching between edit and view modes, update the form values
    if (!isEditing && formRef && formRef.current) {
      const currentValues = formRef.current.getFieldsValue();
      setFormValues(prev => ({ ...prev, ...currentValues }));
    }
  }, [isEditing, formRef]);

  // Function to render form items based on field type
  const renderFormItem = (field) => {
    const { id, name, field_type, required, disabled, field_options } = field;
    
    // Set required rule if specified
    const rules = required ? [{ required: true, message: `Please enter ${name}` }] : [];
    
    switch (field_type) {
      case "text_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input disabled={disabled} />
          </Form.Item>
        );
      case "date_field":
        return (
          <Form.Item label={name} name={id} rules={rules} getValueProps={(value) => {
            // Ensure value is a moment object
            if (value && !moment.isMoment(value)) {
              return { value: moment(value) };
            }
            return { value };
          }}>
            <DatePicker 
              placeholder="Select Date" 
              style={{ width: '100%' }} 
              disabled={disabled}
              // disabledDate={disabledDate}
              showTime={name.includes("TIME")}
              format={name.includes("TIME") ? "DD MMM YYYY HH:mm" : "DD MMM YYYY"}
              suffixIcon={<span className="ant-picker-suffix"></span>}
            />
          </Form.Item>
        );
      case "select_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Select placeholder={`Select ${name}`} disabled={disabled}>
              {field_options?.map(option => (
                <Select.Option key={option.id} value={option.id}>{option.name}</Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      case "date_field":
        return (
          <Form.Item label={name} name={id} rules={rules} getValueProps={(value) => {
            // Ensure value is a moment object
            if (value && !moment.isMoment(value)) {
              return { value: moment(value) };
            }
            return { value };
          }}>
            <DatePicker 
              showTime={name.includes("TIME")} 
              style={{ width: '100%' }} 
              disabled={disabled}
              // disabledDate={disabledDate}
              format={name.includes("TIME") ? "DD MMM YYYY HH:mm" : "DD MMM YYYY"}
            />
          </Form.Item>
        );
      case "upload_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Upload>
              <Button icon={<UploadOutlined />}>Upload</Button>
            </Upload>
          </Form.Item>
        );
      case "textarea_field":
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input.TextArea rows={4} disabled={disabled} />
          </Form.Item>
        );
      default:
        return (
          <Form.Item label={name} name={id} rules={rules}>
            <Input disabled={disabled} />
          </Form.Item>
        );
    }
  };

  // Check if this is a Material form
  const isMaterialForm = fields.some(field => field.id === "areaName" && field.id === "materialSpec");
  const isBoltsForm = fields.some(field => field.id === "area" && field.id === "size");

  // If this is a Bolts form, render the bolts layout
  if (isBoltsForm || (record && record.type === "Bolts")) {
    return (
      <Row>
        <Col span={24}>
          <Form
            className="ims-doc-fields-form"
            form={formRef}
            onFinish={onFinish}
            layout="vertical"
          >
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="AREA NAME *" name="areaName" rules={[{ required: true, message: "Please enter Area Name" }]}>
                    <Input placeholder="Area Name" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">AREA NAME</div>
                    <div className="view-field-value">{formValues.areaName || record.areaName || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
              {isEditing ? (
                  <Form.Item label="ORIGINAL PRIORITY *" name="originalPriorityId" rules={[{ required: true, message: "Please select Original Priority" }]}>
                    <Select placeholder="Select Priority" loading={fetchPrioritiesLoading}>
                      {projectPriorities && projectPriorities.length > 0 && (
                        projectPriorities.map((priority) => (
                          <Select.Option key={priority.id} value={priority.id}>
                            {priority.name}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">ORIGINAL PRIORITY</div>
                    <div className="view-field-value">
                      {(() => {
                        const priorityId = formValues.originalPriorityId || record.originalPriorityId;
                        const priority = projectPriorities?.find(p => p.id === priorityId);
                        return priority ? priority.name : '-';
                      })()}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="NEW PRIORITY" name="newPriorityId">
                    <Select placeholder="New Priority" loading={fetchPrioritiesLoading}>
                      {projectPriorities && projectPriorities.length > 0 && (
                        projectPriorities.map((priority) => (
                          <Select.Option key={priority.id} value={priority.id}>
                            {priority.name}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">NEW PRIORITY
                      {!priorityEditMode && mcPermissions?.edit?.newPriority && (
                        <span 
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            setPriorityEditMode(true);
                            setSelectedPriority(formValues.newPriorityId || record.newPriorityId || null);
                          }}
                        >
                          <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                        </span>
                      )}
                    </div>
                    <div className="view-field-value">
                      {priorityEditMode ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Select
                            style={{ width: '80%' }}
                            placeholder="Select priority"
                            value={selectedPriority || formValues.newPriorityId || record.newPriorityId}
                            onChange={(value) => setSelectedPriority(value)}
                            size="small"
                            loading={fetchPrioritiesLoading}
                          >
                            {projectPriorities?.map((priority) => (
                              <Select.Option key={priority.id} value={priority.id}>
                                {priority.name}
                              </Select.Option>
                            ))}
                          </Select>
                          <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                            <SaveOutlined 
                              onClick={(e) => {
                                e.stopPropagation();
                                
                                // Get the selected value
                                const value = selectedPriority || formValues.newPriorityId || record.newPriorityId;
                                
                                // Update the form values
                                const updatedValues = { ...formValues, newPriorityId: value };
                                setFormValues(updatedValues);
                                
                                // Update the form in Redux
                                if (formRef && formRef.current) {
                                  formRef.current.setFieldsValue({ newPriorityId: value });
                                }
                                
                                // Make API call to update the record
                                updateMaterialControlRecord({ newPriorityId: value });
                                
                                // Reset selected priority and exit edit mode
                                setSelectedPriority(null);
                                setPriorityEditMode(false);
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                            <CloseOutlined 
                              onClick={() => {
                                // Reset selected priority and exit edit mode without saving
                                setSelectedPriority(null);
                                setPriorityEditMode(false);
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                          </div>
                        </div>
                      ) : (
                        formValues.newPriorityId ? 
                          projectPriorities?.find(p => p.id === formValues.newPriorityId)?.name || '-' : 
                          projectPriorities?.find(p => p.id === record.newPriorityId)?.name || '-'
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="UNIT SUBTOTAL / NET *" name="unitSubtotal" rules={[{ required: true, message: "Please enter Unit Subtotal" }]}>
                    <Input placeholder="Unit Subtotal / Net" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">UNIT SUBTOTAL / NET</div>
                    <div className="view-field-value">{formValues.unitSubtotal || record.unitSubtotal || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="UNIT WEIGHT (kg)" name="unitWeight">
                    <Input placeholder="Unit Weight" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">UNIT WEIGHT (kg)</div>
                    <div className="view-field-value">{formValues.unitWeight || record.unitWeight || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="TOTAL WEIGHT (kg)" name="totalWeight">
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">TOTAL WEIGHT (kg)</div>
                    <div className="view-field-value">{Number(record.totalWeight).toFixed(3) || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="SIZE *" name="size" rules={[{ required: true, message: "Please enter Size" }]}>
                    <Input placeholder="Size" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">SIZE</div>
                    <div className="view-field-value">{formValues.size || record.size || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="LENGTH (mm) *" name="length" rules={[{ required: true, message: "Please enter Length" }]}>
                    <Input placeholder="Length" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">LENGTH (mm)</div>
                    <div className="view-field-value">{formValues.length || record.length || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="MODEL" name="model">
                    <Input placeholder="Model" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">MODEL</div>
                    <div className="view-field-value">{formValues.model || record.model || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="MATERIAL FINISH *" name="materialFinish" rules={[{ required: true, message: "Please enter Material Finish" }]}>
                    <Input placeholder="Material Finish" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">MATERIAL FINISH</div>
                    <div className="view-field-value">{formValues.materialFinish || record.materialFinish || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="GRADE *" name="grade" rules={[{ required: true, message: "Please enter Grade" }]}>
                    <Input placeholder="Grade" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">GRADE</div>
                    <div className="view-field-value">{formValues.grade || record.grade || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="FASTENER TYPE *" name="fastenerType" rules={[{ required: true, message: "Please enter Fastener Type" }]}>
                    <Input placeholder="Fastener Type" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">FASTENER TYPE</div>
                    <div className="view-field-value">{formValues.fastenerType || record.fastenerType || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="SUPPLIER" name="supplierId">
                    <Select placeholder="Select Supplier" loading={suppliersLoading}>
                      {allSuppliers && allSuppliers.map(supplier => (
                        <Select.Option key={supplier.id} value={supplier.id}>{supplier.name}</Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">SUPPLIER</div>
                    <div className="view-field-value">
                      {formValues.supplierId ? 
                        allSuppliers?.find(s => s.id === formValues.supplierId)?.name || record.supplierId : 
                        allSuppliers?.find(s => s.id === record.supplierId)?.name || '-'}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                <div className="view-field-container">
                  <div className="view-field-label">ATTACHMENTS</div>
                  <div className="view-field-value">
                    <AttachmentContainer
                      onUpdate={refreshData}
                      color="#f25003"
                      record={record}
                      recordType="material_control_register"
                    />
                  </div>
                </div>
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="COMMENTS" name="comments">
                    <Input placeholder="Comments" />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">COMMENTS
                      {!commentsEditMode && mcPermissions?.edit?.comments && (
                        <span 
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            setCommentsEditMode(true);
                            setEditedComments(formValues.comments || record.comments || '');
                          }}
                        >
                          <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                        </span>
                      )}
                    </div>
                    <div className="view-field-value">
                      {commentsEditMode ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Input
                            style={{ width: '80%' }}
                            placeholder="Enter comments"
                            value={editedComments}
                            onChange={(e) => setEditedComments(e.target.value)}
                            size="small"
                          />
                          <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                            <SaveOutlined 
                              onClick={(e) => {
                                e.stopPropagation();
                                
                                // Update the form values
                                const updatedValues = { ...formValues, comments: editedComments };
                                setFormValues(updatedValues);
                                
                                // Update the form in Redux
                                if (formRef && formRef.current) {
                                  formRef.current.setFieldsValue({ comments: editedComments });
                                }
                                
                                // Make API call to update the record
                                updateMaterialControlRecord({ comments: editedComments });
                                
                                // Exit edit mode
                                setCommentsEditMode(false);
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                            <CloseOutlined 
                              onClick={() => {
                                // Exit edit mode without saving
                                setCommentsEditMode(false);
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                          </div>
                        </div>
                      ) : (
                        formValues.comments || record.comments || '-'
                      )}
                    </div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="STATUS *" name="status" rules={[{ required: true, message: "Please select Status" }]}>
                    <Select placeholder="Select Status">
                      <Select.Option value="Active">Active</Select.Option>
                      <Select.Option value="On Hold">On Hold</Select.Option>
                    </Select>
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="view-field-label">STATUS
                      {!statusEditMode && mcPermissions?.edit?.status && (
                        <span 
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            setStatusEditMode(true);
                            setSelectedStatus(formValues.status || record.status || null);
                            // If status is On Hold, also set onHoldReason edit mode
                            if ((formValues.status || record.status) === 'On Hold') {
                              setOnHoldReasonEditMode(true);
                              setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                            }
                          }}
                        >
                          <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                        </span>
                      )}
                    </div>
                    <div className="view-field-value">
                      {statusEditMode ? (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Select
                            style={{ width: '80%' }}
                            placeholder="Select status"
                            value={selectedStatus || formValues.status || record.status}
                            onChange={(value) => {
                              setSelectedStatus(value);
                              // If changing to On Hold, enable onHoldReason edit mode
                              if (value === 'On Hold') {
                                setOnHoldReasonEditMode(true);
                                setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                              }
                              // If changing from On Hold to something else, reset onHoldReason edit mode
                              else if (onHoldReasonEditMode) {
                                setOnHoldReasonEditMode(false);
                              }
                            }}
                            size="small"
                          >
                            <Select.Option value="Active">Active</Select.Option>
                            <Select.Option value="On Hold">On Hold</Select.Option>
                          </Select>
                          <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                            <SaveOutlined 
                              onClick={(e) => {
                                e.stopPropagation();
                                
                                // Get the selected value
                                const value = selectedStatus || formValues.status || record.status;
                                
                                // Update the form values
                                const updatedValues = { ...formValues, status: value };
                                setFormValues(updatedValues);
                                
                                // Update the form in Redux
                                if (formRef && formRef.current) {
                                  formRef.current.setFieldsValue({ status: value });
                                }
                                
                                // Make API call to update the record
                                // If status is On Hold, also save the reason
                                if (value === 'On Hold') {
                                  // Validate input if status is On Hold
                                  if (!editedOnHoldReason.trim()) {
                                    message.error('Please provide a reason for putting on hold');
                                    return;
                                  }
                                  updateMaterialControlRecord({ 
                                    status: value,
                                    onHoldReason: editedOnHoldReason,
                                    onHoldAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                                    onHoldById: currentUser?.id
                                  });
                                } else {
                                  updateMaterialControlRecord({ status: value });
                                }
                                
                                // Reset selected status and exit edit mode
                                setSelectedStatus(null);
                                setStatusEditMode(false);
                                // Also reset onHoldReason edit mode if it's active
                                if (onHoldReasonEditMode) {
                                  setOnHoldReasonEditMode(false);
                                }
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                            <CloseOutlined 
                              onClick={() => {
                                // Reset selected status and exit edit mode without saving
                                setSelectedStatus(null);
                                setStatusEditMode(false);
                                // Also reset onHoldReason edit mode if it's active
                                if (onHoldReasonEditMode) {
                                  setOnHoldReasonEditMode(false);
                                }
                              }} 
                              style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                            />
                          </div>
                        </div>
                      ) : (
                        formValues.status || record.status || '-'
                      )}
                    </div>
                  </div>
                )}
              </Col>
              {isEditing && (
                <Form.Item
                  noStyle
                  shouldUpdate={(prevValues, currentValues) => prevValues.status !== currentValues.status}
                >
                  {({ getFieldValue }) => {
                    const currentStatus = getFieldValue('status') || selectedStatus || formValues.status || record.status;
                    return currentStatus === 'On Hold' ? (
                      <Col span={6}>
                        <Form.Item
                          label="ON HOLD REASON *"
                          name="onHoldReason"
                          rules={[{ required: true, message: "Please provide reason for putting on hold" }]}
                        >
                          <Input.TextArea
                            style={{ marginTop: '10px' }}
                            placeholder="Enter reason for putting this item on hold"
                            rows={3}
                          />
                        </Form.Item>
                      </Col>
                    ) : null;
                  }}
                </Form.Item>
              )}
              {(!isEditing && ((formValues.status === 'On Hold' || record.status === 'On Hold') || (statusEditMode && selectedStatus === 'On Hold'))) && (
                <Col span={6}>
                  <div className="view-field-container">
                    <div className="view-field-label" style={{ marginBottom: '8px' }}>ON HOLD REASON *
                      {!onHoldReasonEditMode && statusEditMode && ((formValues.status === 'On Hold' || record.status === 'On Hold' || selectedStatus === 'On Hold')) && mcPermissions?.edit?.status && (
                        <span 
                          style={{ marginLeft: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            setOnHoldReasonEditMode(true);
                            setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                          }}
                        >
                          <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                        </span>
                      )}
                    </div>
                    <div className="view-field-value">
                      {onHoldReasonEditMode ? (
                        <Form.Item
                          style={{ marginBottom: 0 }}
                        >
                          <Input.TextArea
                            value={editedOnHoldReason}
                            onChange={(e) => setEditedOnHoldReason(e.target.value)}
                            style={{ maxWidth: '100%' }}
                            rows={2}
                          />
                        </Form.Item>
                      ) : (
                        formValues.onHoldReason || record.onHoldReason || '-'
                      )}
                    </div>
                  </div>
                </Col>
              )}
              {(!isEditing && ((formValues.status === 'On Hold' || record.status === 'On Hold') || (statusEditMode && selectedStatus === 'On Hold'))) && (
                <Col span={6}>
                  <div className="view-field-container">
                    <div className="view-field-label">ON HOLD DETAILS</div>
                    <div className="view-field-value">
                      <div>Date: {statusEditMode && selectedStatus === 'On Hold' ? moment().format("DD MMM YYYY") : (record.onHoldAt ? moment(record.onHoldAt).format("DD MMM YYYY") : '-')}</div>
                      <div>Changed By: {statusEditMode && selectedStatus === 'On Hold' ? (currentUser && `${currentUser.firstName} ${currentUser.lastName}`) : (onHoldUser ? `${onHoldUser.firstName} ${onHoldUser.lastName}` : '-')}</div>
                    </div>
                  </div>
                </Col>
              )}
            </Row>
            <div className="created-modified-field-group">          
            <Row gutter={[20, 10]}>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="CREATED BY" name="createdById">
                    <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="created-modified-field-label">CREATED BY</div>
                    <div className="created-modified-field-value">{ record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : formValues.createdById || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="CREATED DATE & TIME" name="createdDate">
                    <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="created-modified-field-label">CREATED DATE & TIME</div>
                    <div className="created-modified-field-value">{formValues.createdDate || (record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : '-')}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="MODIFIED BY" name="updatedById">
                    <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="created-modified-field-label">MODIFIED BY</div>
                    <div className="created-modified-field-value">{ formValues.updatedBy && formValues.updatedBy.firstName + " " + formValues.updatedBy.lastName ||record.updatedById && updatedBy && `${updatedBy.firstName} ${updatedBy.lastName}` || '-'}</div>
                  </div>
                )}
              </Col>
              <Col span={6}>
                {isEditing ? (
                  <Form.Item label="MODIFIED DATE & TIME" name="modifiedDate">
                    <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                  </Form.Item>
                ) : (
                  <div className="view-field-container">
                    <div className="created-modified-field-label">MODIFIED DATE & TIME</div>
                    <div className="created-modified-field-value">{formValues.modifiedDate || (record.updatedAt ? moment(record.updatedAt).format("DD MMM YYYY HH:mm") : '-') || '-'}</div>
                  </div>
                )}
              </Col>
            </Row>
            </div>
            {/* Dynamic fields from template */}
            {fields.filter(field => ![
              'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'unitWeight', 'totalWeight',
              'size', 'length', 'model', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'attachments',
              'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
            ].includes(field.id)).length > 0 && (
              <>
                <Row>
                  <Col span={24}>
                    <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
                </Row>
                <Row gutter={[20, 10]} style={{ position: 'relative' }}>
                  {!isEditing && (
                    <div style={{ position: 'absolute', top: '5px', right: '20px', zIndex: 1 }}>
                      {dynamicFieldsEditMode ? (
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <SaveOutlined 
                            onClick={() => {
                              // Save all dynamic field values
                              const updateData = {};
                              
                              // Create materialTemplateFields object with all edited values as strings
                              Object.keys(dynamicFieldValues).forEach(fieldId => {
                                // Convert all values to strings to ensure consistency
                                updateData[fieldId] = dynamicFieldValues[fieldId] !== null && dynamicFieldValues[fieldId] !== undefined ? String(dynamicFieldValues[fieldId]) : '';
                              });
                              
                              // Update form values
                              const updatedFormValues = { ...formValues };
                              Object.keys(dynamicFieldValues).forEach(fieldId => {
                                updatedFormValues[fieldId] = dynamicFieldValues[fieldId];
                              });
                              setFormValues(updatedFormValues);
                              
                              // Update Redux form
                              if (formRef && formRef.current) {
                                formRef.current.setFieldsValue(dynamicFieldValues);
                              }
                              
                              // Make API call to update the record
                              if (Object.keys(updateData).length > 0) {
                                updateMaterialControlRecord({
                                  materialTemplateFields: updateData
                                });
                              }
                              
                              // Exit edit mode
                              setDynamicFieldsEditMode(false);
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                          <CloseOutlined 
                            onClick={() => {
                              // Exit edit mode without saving
                              setDynamicFieldsEditMode(false);
                              // Reset dynamic field values
                              setDynamicFieldValues({});
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                        </div>
                      ) : (
                        mcPermissions?.edit?.template_fields && (
                          <span 
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              // Enter edit mode
                              setDynamicFieldsEditMode(true);
                              
                              // Initialize dynamic field values with current values
                              const initialValues = {};
                              fields.filter(field => ![
                                'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'unitWeight', 'totalWeight',
                                'size', 'length', 'model', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'commodityId', 'attachments',
                                'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                              ].includes(field.id)).forEach(field => {
                                initialValues[field.id] = formValues[field.id] || 
                                  (record.materialTemplateFields && record.materialTemplateFields[field.id]) || '';
                              });
                              setDynamicFieldValues(initialValues);
                            }}
                          >
                            <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                          </span>
                        )
                      )}
                    </div>
                  )}
                  {fields.filter(field => ![
                        'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'unitWeight', 'totalWeight',
                        'size', 'length', 'model', 'materialFinish', 'grade', 'fastenerType', 'supplierId', 'commodityId', 'attachments',
                        'comments', 'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                  ].includes(field.id)).map(field => {
                    const { id, name, field_type, field_options } = field;
                    
                    // Format the value based on field type for display
                    let displayValue = formValues[id] || (record.materialTemplateFields && record.materialTemplateFields[id]) || '-';
                    if (field_type === "select_field" && field_options && Array.isArray(field_options)) {
                      // Parse the value to integer if it's a numeric string
                      if (typeof displayValue === 'string' && !isNaN(displayValue)) {
                        displayValue = parseInt(displayValue);
                      }
                      const option = field_options.find(opt => opt.id === displayValue || opt.value === displayValue);
                      displayValue = option ? option.name : displayValue;
                    } else if (field_type === "date_field" && displayValue && displayValue !== '-') {
                      try {
                        displayValue = moment(displayValue).format('DD MMM YYYY');
                      } catch (e) {
                        // If date parsing fails, use the original value
                      }
                    }
                    
                    return (
                      <Col span={6} key={id}>
                        {isEditing ? (
                          renderFormItem(field)
                        ) : (
                          <div className="view-field-container">
                            <div className="view-field-label">{name}</div>
                            <div className="view-field-value">
                              {dynamicFieldsEditMode ? (
                                field_type === "select_field" ? (
                                  <Select
                                    style={{ width: '100%', maxWidth: '200px' }}
                                    placeholder={`Select ${name}`}
                                    value={dynamicFieldValues[id]}
                                    onChange={(value) => setDynamicFieldValues(prev => ({ ...prev, [id]: value }))}
                                    size="small"
                                    dropdownMatchSelectWidth={false}
                                  >
                                    {field_options && Array.isArray(field_options) && field_options.map(option => (
                                      <Select.Option key={option.id || option.value} value={option.id || option.value}>
                                        {option.name}
                                      </Select.Option>
                                    ))}
                                  </Select>
                                ) : field_type === "date_field" ? (
                                  <div className="custom-datepicker-wrapper">
                                    <DatePicker
                                      style={{ width: '100%', maxWidth: '200px' }}
                                      value={dynamicFieldValues[id] ? moment(dynamicFieldValues[id]) : null}
                                      onChange={(date) => setDynamicFieldValues(prev => ({ ...prev, [id]: date ? date.format('YYYY-MM-DD') : null }))}
                                      // disabledDate={disabledDate}
                                      size="small"
                                      format="DD MMM YYYY"
                                      suffixIcon={null}
                                    />
                                  </div>
                                ) : (
                                  <Input
                                    style={{ width: '100%', maxWidth: '200px' }}
                                    value={dynamicFieldValues[id]}
                                    onChange={(e) => setDynamicFieldValues(prev => ({ ...prev, [id]: e.target.value }))}
                                    size="small"
                                  />
                                )
                              ) : (
                                displayValue
                              )}
                            </div>
                          </div>
                        )}
                      </Col>
                    );
                  })}
                </Row>
                <Row>
                  <Col span={24}>
                    <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                  </Col>
                </Row>
              </>
            )}
            {/* Only show tracking stages when record has been saved (has an ID and is not in editing mode) */}
            {record && record.id && !isEditing && (
              <Row gutter={[16, 10]} style={{ marginTop: '15px'}}>
                <Col span={4}>
                  <div className="tracking-stage fabrication-stage">
                    <div className="tracking-stage-header">FABRICATION</div>
                    <div className="tracking-stage-status">
                      <div className={`status-badge ${fabrication && fabrication.status === 'completed' ? 'completed' : (fabrication && fabrication.status === 'in_progress' ? 'in-progress' : (fabrication && fabrication.status === 'received' ? 'received' : ''))}`}>
                        {fabrication && fabrication.status ? 
                          fabrication.status === 'in_progress' ? 'In Progress' : 
                          fabrication.status.charAt(0).toUpperCase() + fabrication.status.slice(1) 
                        : 'Not Started'}
                      </div>
                    </div>
                    <div className="field-group mark-recieved">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {datePickerVisible ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              size="small" 
                              className="date-picker-small"
                              onChange={(date) => setSelectedDate(date)}
                              value={selectedDate}
                              suffixIcon={null} /* Hide the default calendar icon */
                              format="DD MMM YYYY" /* Format the date display */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('fabrication')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDatePickerVisible(false);
                                  setQtyInputVisible(false);
                                  setSelectedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (fabrication && fabrication.receivedAt) ? (
                          <div className="saved-date-display">
                            {moment(fabrication.receivedAt).format('DD MMM YYYY')}
                            {mcPermissions?.fabrication?.mark_received && !isProjectOnHold() && (
                            <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" />
                              <div 
                                onClick={() => {
                                  setDatePickerVisible(true);
                                  setQtyInputVisible(true);
                                }}
                                className="edit-date-icon"
                              >
                                <EditOutlined className="edit-icon" />
                              </div>
                            </div>
                            )}
                          </div>
                        ) : mcPermissions?.fabrication?.mark_received && !isProjectOnHold() && (
                          <div className="tick-box-container">
                            <div 
                              onClick={() => {
                                setDatePickerVisible(true);
                                setQtyInputVisible(true);
                              }}
                              className="tick-box"
                            >
                              <CheckOutlined style={{ fontSize: '16px' }} />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {qtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={receivedQty}
                              onChange={(e) => setReceivedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : qtyIsSaved && receivedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(receivedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {receivedQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isAuthorized}
                              type="fabrication"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedLocation}
                              onChange={(value) => setSelectedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qtyIsSaved && selectedLocation ? (
                          <div className="saved-location-display">
                            {allLocations && allLocations.find(loc => loc.id === selectedLocation)?.name || ''}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {updatedByUser || ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {completedDatePickerVisible && mcPermissions?.fabrication?.mark_completed ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              size="small" 
                              className="date-picker-small"
                              onChange={(date) => setSelectedCompletedDate(date)}
                              value={selectedCompletedDate}
                              suffixIcon={null} /* Hide the default calendar icon */
                              format="DD MMM YYYY" /* Format the date display */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('fabrication')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setCompletedDatePickerVisible(false);
                                  setCompletedQtyInputVisible(false);
                                  setSelectedCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (fabrication && fabrication.completedAt) ? (
                          <div className="saved-date-display">
                            {moment(fabrication.completedAt).format('DD MMM YYYY')}
                            {mcPermissions?.fabrication?.mark_completed && !isProjectOnHold() && (
                            <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" />
                              <div 
                                onClick={() => {
                                  setCompletedDatePickerVisible(true);
                                  setCompletedQtyInputVisible(true);
                                }}
                                className="edit-date-icon"
                              >
                                <EditOutlined className="edit-icon"/>
                              </div>
                            </div>
                            )}
                          </div>
                        ) : (
                          isItemReceived ? (
                            mcPermissions?.fabrication?.mark_completed && !isProjectOnHold() && 
                            !(needsAuthorization(receivedQty, record.qty, maxAuthorizeValue, false) && !authorizationReceivedData) && (
                            <div className="tick-box-container mark-completed">
                              <div 
                                onClick={() => {
                                  setCompletedDatePickerVisible(true);
                                  setCompletedQtyInputVisible(true);
                                }}
                                className="tick-box"
                              >
                                <CheckOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                            )
                          ) : null
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {completedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={completedQty}
                              onChange={(e) => setCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : completedQtyIsSaved && completedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(completedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {completedQty} of {record.qty || 1}
                            </span>
                            {Number(completedQty) > Number(record.qty || 1) && (
                              <AuthorizeExcess
                                receivedQty={completedQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isCompletedAuthorized}
                                type="fabrication"
                                onAuthorize={handleSaveMarkCompleted}
                                authorizationData={authorizationCompletedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {completedDatePickerVisible ? (
                          <div className="location-container">
                            <Select
                              placeholder="Select Location"
                              style={{ width: '100%' }}
                              size="small"
                              onChange={(value) => setSelectedCompletedLocation(value)}
                              value={selectedCompletedLocation}
                              loading={locationsLoading}
                            >
                              {allLocations?.map((location) => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : completedDateIsSaved && selectedCompletedLocation ? (
                          <div className="saved-location-display">
                            {allLocations?.find(loc => loc.id === selectedCompletedLocation)?.name || 'Unknown Location'}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {completedByUser || ""}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { grossCompleted ? `${grossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {supplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedSupplierForTracking}
                              onChange={(value) => setSelectedSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('fabrication', fabrication, selectedSupplierForTracking);
                                  setSupplierEditMode(false);
                                }}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSupplierEditMode(false);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.fabrication?.update_supplier && !isProjectOnHold() && (
                            <EditOutlined 
                              className="edit-icon"
                              style={{fill: '#8e44ad'}} 
                              onClick={() => {
                                setSupplierEditMode(true);
                              }}
                            />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#8e44ad"
                          recordType="fabrication"
                          record={fabrication}
                          canAdd={mcPermissions?.fabrication?.add_attachments}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage qc-release-stage">
                  <div className="tracking-stage-header">QC RELEASE</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${qcRelease && qcRelease.status === 'completed' ? 'completed' : (qcRelease && qcRelease.status === 'in_progress' ? 'in-progress' : (qcRelease && qcRelease.status === 'received' ? 'received' : ''))}`}>
                        {qcRelease && qcRelease.status ? 
                          qcRelease.status === 'in_progress' ? 'In Progress' : 
                          qcRelease.status.charAt(0).toUpperCase() + qcRelease.status.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      {isQCReleaseReady && !qcDatePickerVisible && !qcDateIsSaved ? (
                        mcPermissions?.qc_release?.mark_received && !isProjectOnHold() && 
                        !(needsAuthorization(completedQty, record.qty, maxAuthorizeValue, false)) && (
                        <div className="tick-box-container mark-completed" style={{ color: '#c0392b' }}>
                          <div onClick={() => { 
                            setQcDatePickerVisible(true);
                            setQcQtyInputVisible(true);
                          }} className="tick-box-qc" style={{ color: '#c0392b' }}>
                            <CheckOutlined style={{ color: '#c0392b' }}/>
                          </div>
                        </div>
                        )
                      ) : qcDatePickerVisible && mcPermissions?.qc_release?.mark_received && !isProjectOnHold() ? (
                        <div className="date-picker-container">
                          <DatePicker 
                            className="date-picker-small"
                            value={selectedQcDate}
                            onChange={(date) => setSelectedQcDate(date)}
                            format="DD MMM YYYY"
                            placeholder="Select date"
                            size="small"
                            suffixIcon={null} /* Hide the default calendar icon */
                            disabledDate={disabledDate}
                          />
                          <div className="action-icons-container">
                            <div 
                              onClick={() => handleSaveMarkRecieved('qc_release')}
                              className="action-icon save"
                            >
                              <SaveOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                            </div>
                            <div 
                              onClick={() => {
                                setQcDatePickerVisible(false);
                                setQcQtyInputVisible(false);
                                setSelectedQcDate(null);
                              }}
                              className="action-icon close"
                            >
                              <CloseOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                            </div>
                          </div>
                        </div>
                      ) : (qcRelease && qcRelease.receivedAt) ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(qcRelease.receivedAt).format('DD MMM YYYY')}</span>
                          {mcPermissions?.qc_release?.mark_received && !isProjectOnHold() ? (
                            <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#c0392b' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#c0392b' }} 
                                onClick={() => {
                                  setQcDatePickerVisible(true);
                                  setQcQtyInputVisible(true);
                                }}
                              />
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {qcQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={qcQty}
                                onChange={(e) => setQcQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : qcQtyIsSaved && qcQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(qcQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {qcQty} of {record.qty || 1}
                              </span>
                              <AuthorizeExcess
                                receivedQty={qcQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isQcAuthorized}
                                type="qc_release"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationQcReceivedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qcQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedQcLocation}
                              onChange={(value) => setSelectedQcLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qcDateIsSaved && selectedQcLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedQcLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{qcByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {qcDateIsSaved && !qcCompletedDatePickerVisible && !qcCompletedDateIsSaved && mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(qcQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#c0392b' }}>
                            <div onClick={() => { 
                              setQcCompletedDatePickerVisible(true);
                              setQcCompletedQtyInputVisible(true);
                            }} className="tick-box-completed" style={{ color: '#c0392b' }}>
                              <CheckOutlined style={{ color: '#c0392b' }}/>
                            </div>
                          </div>
                        ) : qcCompletedDatePickerVisible && mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedQcCompletedDate}
                              onChange={(date) => setSelectedQcCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('qc_release')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setQcCompletedDatePickerVisible(false);
                                  setQcCompletedQtyInputVisible(false);
                                  setSelectedQcCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                              </div>
                            </div>
                          </div>
                        ) : (qcRelease && qcRelease.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(qcRelease.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#c0392b' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#c0392b' }} 
                                onClick={() => {
                                  setQcCompletedDatePickerVisible(true);
                                  setQcCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          {qcCompletedQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={qcCompletedQty}
                                onChange={(e) => setQcCompletedQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : qcCompletedQtyIsSaved && qcCompletedQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(qcCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {qcCompletedQty} of {record.qty || 1}
                              </span>
                              {Number(qcCompletedQty) > Number(record.qty || 1) && (
                                <AuthorizeExcess
                                  receivedQty={qcCompletedQty}
                                  expectedQty={record.qty || 1}
                                  record={record}
                                  currentUser={currentUser}
                                  isAuthorized={isQcCompletedAuthorized}
                                  type="qc_release"
                                  onAuthorize={handleSaveMarkCompleted}
                                  authorizationData={authorizationQcCompletedData}
                                  maxAuthorizeValue={maxAuthorizeValue}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qcCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedQcCompletedLocation}
                              onChange={(value) => setSelectedQcCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qcCompletedDateIsSaved && selectedQcCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedQcCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{qcCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { qcGrossCompleted ? `${qcGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {qcSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedQcSupplierForTracking}
                              onChange={(value) => setSelectedQcSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('qc_release', qcRelease, selectedQcSupplierForTracking);
                                  setQcSupplierEditMode(false);
                                }}
                                style={{color: '#c0392b'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setQcSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#c0392b'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedQcSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedQcSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.qc_release?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setQcSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#c0392b'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#c0392b"
                          recordType="qc_release"
                          record={qcRelease}
                          canAdd={mcPermissions?.qc_release?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                        <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#c0392b"
                          materialControlRegisterId={record?.id}
                          progressStepType="qc_release"
                          onCountChange={setQcDeliveryNotesCount}
                          projectId={project_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-to-workshop-stage">
                  <div className="tracking-stage-header">DELIVERY TO WSHP</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${corrosionProtection && corrosionProtection.status === 'completed' ? 'completed' : (corrosionProtection && corrosionProtection.status === 'in_progress' ? 'in-progress' : (corrosionProtection && corrosionProtection.status === 'received' ? 'received' : ''))}`}>
                        {corrosionProtection && corrosionProtection.status ? 
                          corrosionProtection.status === 'in_progress' ? 'In Progress' : 
                          corrosionProtection.status.charAt(0).toUpperCase() + corrosionProtection.status.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      {isCorrosionProtectionReady && !corrosionDatePickerVisible && !corrosionDateIsSaved && mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() &&
                      !(needsAuthorization(qcCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                        <div className="tick-box-container mark-completed" style={{ color: '#ffc000'}}>
                          <div onClick={() => { 
                            setCorrosionDatePickerVisible(true);
                            setCorrosionQtyInputVisible(true);
                          }} className="tick-box-cc" style={{ color: '#ffc000' }}>
                            <CheckOutlined style={{ color: '#ffc000' }}/>
                          </div>
                        </div>
                      ) : corrosionDatePickerVisible && mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() ? (
                        <div className="date-picker-container">
                          <DatePicker 
                            className="date-picker-small"
                            value={selectedCorrosionDate}
                            onChange={(date) => setSelectedCorrosionDate(date)}
                            format="DD MMM YYYY"
                            placeholder="Select date"
                            size="small"
                            suffixIcon={null} /* Hide the default calendar icon */
                            disabledDate={disabledDate}
                          />
                          <div className="action-icons-container">
                            <div 
                              onClick={() => handleSaveMarkRecieved('corrosion_protection')}
                              className="action-icon save"
                            >
                              <SaveOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                            </div>
                            <div 
                              onClick={() => {
                                setCorrosionDatePickerVisible(false);
                                setCorrosionQtyInputVisible(false);
                                setSelectedCorrosionDate(null);
                              }}
                              className="action-icon close"
                            >
                              <CloseOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                            </div>
                          </div>
                        </div>
                      ) : (corrosionProtection && corrosionProtection.receivedAt && corrisonSignedDeliveryNote) ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(corrosionProtection.receivedAt).format('DD MMM YYYY')}</span>
                          {mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() && <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                            <AttachmentContainer
                              onUpdate={refreshData}
                              color="#ffc000"
                              recordType="corrosion_protection"
                              additionalData="signedDeliveryNote"
                              visibility={true}
                              record={corrosionProtection}
                            />
                            <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                            <EditOutlined 
                              className="edit-icon" 
                              style={{ fill: '#ffc000' }} 
                              onClick={() => {
                                setCorrosionDatePickerVisible(true);
                                setCorrosionQtyInputVisible(true);
                              }}
                            />
                          </div>}
                        </div>
                      ) : (corrosionProtection && corrosionProtection.receivedAt) ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(corrosionProtection.receivedAt).format('DD MMM YYYY')}</span>
                          {mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() && <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                            <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                            <EditOutlined 
                              className="edit-icon" 
                              style={{ fill: '#ffc000' }} 
                              onClick={() => {
                                setCorrosionDatePickerVisible(true);
                                setCorrosionQtyInputVisible(true);
                              }}
                            />
                          </div>}
                        </div>
                      ) : null}
                      </div>
                    </div>
                    {corrosionQtyInputVisible ? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#ffc000"
                          recordType="corrosion_protection"
                          additionalData="signedDeliveryNote"
                          record={corrosionProtection}
                          onAttachmentCountChange={(count) => {
                            setCorrisonSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                        )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {corrosionQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={corrosionQty}
                                onChange={(e) => setCorrosionQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : corrosionQtyIsSaved && corrosionQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(corrosionQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {corrosionQty} of {record.qty || 1}
                              </span>
                              <AuthorizeExcess
                                receivedQty={corrosionQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isCorrosionAuthorized}
                                type="corrosion_protection"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationCorrosionReceivedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {corrosionQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedCorrosionLocation}
                              onChange={(value) => setSelectedCorrosionLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : corrosionDateIsSaved && selectedCorrosionLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedCorrosionLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{corrosionByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {corrosionDateIsSaved && !corrosionCompletedDatePickerVisible && !corrosionCompletedDateIsSaved && mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(corrosionQty, record.qty, maxAuthorizeValue, isCorrosionCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#ffc000' }}>
                            <div onClick={() => { 
                              setCorrosionCompletedDatePickerVisible(true);
                              setCorrosionCompletedQtyInputVisible(true);
                            }} className="tick-box-cc" style={{ color: '#ffc000' }}>
                              <CheckOutlined style={{ color: '#ffc000' }}/>
                            </div>
                          </div>
                        ) : corrosionCompletedDatePickerVisible && mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedCorrosionCompletedDate}
                              onChange={(date) => setSelectedCorrosionCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('corrosion_protection')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setCorrosionCompletedDatePickerVisible(false);
                                  setCorrosionCompletedQtyInputVisible(false);
                                  setSelectedCorrosionCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                              </div>
                            </div>
                          </div>
                        ) : corrosionCompletedDateIsSaved && selectedCorrosionCompletedDate ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{selectedCorrosionCompletedDate.format('DD MMM YYYY')}</span>
                            {mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#ffc000' }} 
                                onClick={() => {
                                  setCorrosionCompletedDatePickerVisible(true);
                                  setCorrosionCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                     <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          {corrosionCompletedQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={corrosionCompletedQty}
                                onChange={(e) => setCorrosionCompletedQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : corrosionCompletedQtyIsSaved && corrosionCompletedQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(corrosionCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {corrosionCompletedQty} of {record.qty || 1}
                              </span>
                              {Number(corrosionCompletedQty) > Number(record.qty || 1) && (
                                <AuthorizeExcess
                                  receivedQty={corrosionCompletedQty}
                                  expectedQty={record.qty || 1}
                                  record={record}
                                  currentUser={currentUser}
                                  isAuthorized={isCorrosionCompletedAuthorized}
                                  type="corrosion_protection"
                                  onAuthorize={handleSaveMarkCompleted}
                                  authorizationData={authorizationCorrosionCompletedData}
                                  maxAuthorizeValue={maxAuthorizeValue}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                     <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {corrosionCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedCorrosionCompletedLocation}
                              onChange={(value) => setSelectedCorrosionCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : corrosionCompletedDateIsSaved && selectedCorrosionCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedCorrosionCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{corrosionCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { corrosionGrossCompleted ? `${corrosionGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {corrosionSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedCorrosionSupplierForTracking}
                              onChange={(value) => setSelectedCorrosionSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('corrosion_protection', corrosionProtection, selectedCorrosionSupplierForTracking);
                                  setCorrosionSupplierEditMode(false);
                                }}
                                style={{color: '#ffc000'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setCorrosionSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#ffc000'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedCorrosionSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedCorrosionSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.corrosion_protection?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setCorrosionSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#ffc000'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#ffc000"
                          recordType="corrosion_protection"
                          record={corrosionProtection}
                          canAdd={mcPermissions?.corrosion_protection?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field delivery-notes-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                         <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#ffc000"
                          materialControlRegisterId={record?.id}
                          progressStepType="corrosion_protection"
                          onCountChange={setCorrosionDeliveryNotesCount}
                          projectId={project_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-stage">
                  <div className="tracking-stage-header">DELIVERY TO SITE</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${deliveryToSite && deliveryToSite.status === 'completed' ? 'completed' : (deliveryToSite && deliveryToSite.status === 'in_progress' ? 'in-progress' : (deliveryToSite && deliveryToSite.status === 'received' ? 'received' : ''))}`}>
                      {deliveryToSite && deliveryToSite.status ? 
                        deliveryToSite.status === 'in_progress' ? 'In Progress' : 
                        deliveryToSite.status.charAt(0).toUpperCase() + deliveryToSite.status.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {isDeliveryToSiteReady && !deliveryDatePickerVisible && !deliveryDateIsSaved && mcPermissions?.delivery?.mark_received && !isProjectOnHold() &&
                        !(needsAuthorization(corrosionCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#3498db' }}>
                            <div onClick={() => { 
                              setDeliveryDatePickerVisible(true);
                              setDeliveryQtyInputVisible(true);
                            }} className="tick-box-dts" style={{ color: '#3498db' }}>
                              <CheckOutlined style={{ color: '#3498db' }}/>
                            </div>
                          </div>
                        ) : deliveryDatePickerVisible && mcPermissions?.delivery?.mark_received && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedDeliveryDate}
                              onChange={(date) => setSelectedDeliveryDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('delivery_to_site')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(false);
                                  setDeliveryQtyInputVisible(false);
                                  setSelectedDeliveryDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                            </div>
                          </div>
                        ) : (deliveryToSite && deliveryToSite.receivedAt) && deliveryToSiteSignedDeliveryNote ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <AttachmentContainer
                                onUpdate={refreshData}
                                color="#3498db"
                                recordType="delivery_to_site"
                                additionalData="signedDeliveryNote"
                                visibility={true}
                                record={deliveryToSite}
                              />
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(true);
                                  setDeliveryQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : (deliveryToSite && deliveryToSite.receivedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(true);
                                  setDeliveryQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {deliveryQtyInputVisible ? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#3498db"
                          recordType="signed_delivery_note"
                          additionalData="signedDeliveryNote"
                          record={deliveryToSite}
                          onAttachmentCountChange={(count) => {
                            setDeliveryToSiteSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                        )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {deliveryQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={deliveryQty}
                              onChange={(e) => setDeliveryQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : deliveryQtyIsSaved && deliveryQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(deliveryQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {deliveryQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={deliveryQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isDeliveryAuthorized}
                              type="delivery_to_site"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliveryReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {deliveryQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedDeliveryLocation}
                              onChange={(value) => setSelectedDeliveryLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : deliveryDateIsSaved && selectedDeliveryLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedDeliveryLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{deliveryByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {deliveryDateIsSaved && !deliveryCompletedDatePickerVisible && !deliveryCompletedDateIsSaved && mcPermissions?.delivery?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(deliveryQty, record.qty, maxAuthorizeValue, isDeliveryCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#3498db' }}>
                            <div onClick={() => { 
                              setDeliveryCompletedDatePickerVisible(true);
                              setDeliveryCompletedQtyInputVisible(true);
                            }} className="tick-box-dts" style={{ color: '#3498db' }}>
                              <CheckOutlined style={{ color: '#3498db' }}/>
                            </div>
                          </div>
                        ) : deliveryCompletedDatePickerVisible && mcPermissions?.delivery?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedDeliveryCompletedDate}
                              onChange={(date) => setSelectedDeliveryCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('delivery_to_site')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliveryCompletedDatePickerVisible(false);
                                  setDeliveryCompletedQtyInputVisible(false);
                                  setSelectedDeliveryCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                            </div>
                          </div>
                        ) : (deliveryToSite && deliveryToSite.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryCompletedDatePickerVisible(true);
                                  setDeliveryCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {deliveryCompletedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={deliveryCompletedQty}
                              onChange={(e) => setDeliveryCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : deliveryCompletedQtyIsSaved && deliveryCompletedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(deliveryCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {deliveryCompletedQty} of {record.qty || 1}
                            </span>
                            {Number(deliveryCompletedQty) > Number(record.qty || 1) && (
                              <AuthorizeExcess
                                receivedQty={deliveryCompletedQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isDeliveryCompletedAuthorized}
                                type="delivery_to_site"
                                onAuthorize={handleSaveMarkCompleted}
                                authorizationData={authorizationDeliveryCompletedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            )}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {deliveryCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedDeliveryCompletedLocation}
                              onChange={(value) => setSelectedDeliveryCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : deliveryCompletedDateIsSaved && selectedDeliveryCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedDeliveryCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{deliveryCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {deliveryGrossCompleted ? `${deliveryGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {siteReceiptSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedSiteReceiptSupplierForTracking}
                              onChange={(value) => setSelectedSiteReceiptSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('site_receipt', siteReceipt, selectedSiteReceiptSupplierForTracking);
                                  setSiteReceiptSupplierEditMode(false);
                                }}
                                style={{color: '#3498db'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#3498db'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedSiteReceiptSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedSiteReceiptSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.delivery?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setSiteReceiptSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#3498db'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#3498db"
                          recordType="delivery_to_site"
                          record={deliveryToSite}
                          canAdd={mcPermissions?.delivery?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                         <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#3498db"
                          materialControlRegisterId={record?.id}
                          progressStepType="delivery_to_site"
                          onCountChange={setDeliveryToSiteDeliveryNotesCount}
                          projectId={project_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage receipt-stage">
                  <div className="tracking-stage-header">SITE RECEIPT</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${siteReceipt && siteReceipt.status === 'completed' ? 'completed' : (siteReceipt && siteReceipt.status === 'in_progress' ? 'in-progress' : (siteReceipt && siteReceipt.status === 'received' ? 'received' : ''))}`}>
                      {siteReceipt && siteReceipt.status ? 
                        siteReceipt.status === 'in_progress' ? 'In Progress' : 
                        siteReceipt.status.charAt(0).toUpperCase() + siteReceipt.status.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {isDeliveryItemCompleted && !siteReceiptDatePickerVisible && !siteReceiptDateIsSaved && mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() &&
                        !(needsAuthorization(deliveryCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#f5a44d' }}>
                            <div onClick={() => { 
                              setSiteReceiptDatePickerVisible(true);
                              setSiteReceiptQtyInputVisible(true);
                            }} className="tick-box-sr" style={{ color: '#f5a44d' }}>
                              <CheckOutlined style={{ color: '#f5a44d' }}/>
                            </div>
                          </div>
                        ) : siteReceiptDatePickerVisible && mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedSiteReceiptDate}
                              onChange={(date) => setSelectedSiteReceiptDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('site_receipt')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptDatePickerVisible(false);
                                  setSiteReceiptQtyInputVisible(false);
                                  setSelectedSiteReceiptDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                            </div>
                          </div>
                        ) : (siteReceipt && siteReceipt.receivedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(siteReceipt.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#f5a44d' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#f5a44d' }} 
                                onClick={() => {
                                  setSiteReceiptDatePickerVisible(true);
                                  setSiteReceiptQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {siteReceiptQtyInputVisible ? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#f5a44d"
                          recordType="site_receipt"
                          additionalData="signedDeliveryNote"
                          record={siteReceipt}
                          onAttachmentCountChange={(count) => {
                            setSiteReceiptSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                    )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {siteReceiptQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={siteReceiptQty}
                              onChange={(e) => setSiteReceiptQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : siteReceiptQtyIsSaved && siteReceiptQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(siteReceiptQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {siteReceiptQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={siteReceiptQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliverytoSiteReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {siteReceiptQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedSiteReceiptLocation}
                              onChange={(value) => setSelectedSiteReceiptLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : siteReceiptDateIsSaved && selectedSiteReceiptLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedSiteReceiptLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{siteReceiptByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptDateIsSaved && !siteReceiptCompletedDatePickerVisible && !siteReceiptCompletedDateIsSaved && mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(siteReceiptQty, record.qty, maxAuthorizeValue, isSiteReceiptCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#f5a44d' }}>
                            <div onClick={() => { 
                              setSiteReceiptCompletedDatePickerVisible(true);
                              setSiteReceiptCompletedQtyInputVisible(true);
                            }} className="tick-box-sr" style={{ color: '#f5a44d' }}>
                              <CheckOutlined style={{ color: '#f5a44d' }}/>
                            </div>
                          </div>
                        ) : siteReceiptCompletedDatePickerVisible && mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedSiteReceiptCompletedDate}
                              onChange={(date) => setSelectedSiteReceiptCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('site_receipt')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptCompletedDatePickerVisible(false);
                                  setSiteReceiptCompletedQtyInputVisible(false);
                                  setSelectedSiteReceiptCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                            </div>
                          </div>
                        ) : (siteReceipt && siteReceipt.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(siteReceipt.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#f5a44d' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#f5a44d' }} 
                                onClick={() => {
                                  setSiteReceiptCompletedDatePickerVisible(true);
                                  setSiteReceiptCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptCompletedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={siteReceiptCompletedQty}
                              onChange={(e) => setSiteReceiptCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : siteReceiptCompletedQtyIsSaved && siteReceiptCompletedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(siteReceiptCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {siteReceiptCompletedQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={siteReceiptCompletedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptCompletedAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkCompleted}
                              authorizationData={authorizationDeliverytoSiteCompletedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {siteReceiptCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedSiteReceiptCompletedLocation}
                              onChange={(value) => setSelectedSiteReceiptCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : siteReceiptCompletedDateIsSaved && selectedSiteReceiptCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedSiteReceiptCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{siteReceiptCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptGrossCompleted ? `${siteReceiptGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {deliverySupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedDeliverySupplierForTracking}
                              onChange={(value) => setSelectedDeliverySupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('delivery_to_site', deliveryToSite, selectedDeliverySupplierForTracking);
                                  setDeliverySupplierEditMode(false);
                                }}
                                style={{color: '#f5a44d'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliverySupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#f5a44d'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedDeliverySupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedDeliverySupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.site_receipt?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setDeliverySupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#f5a44d'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#f5a44d"
                          recordType="site_receipt"
                          record={siteReceipt}
                          canAdd={mcPermissions?.site_receipt?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-value">
                        <GrvList
                          projectId={project_id}
                          recordType="delivery_to_site"
                          record={siteReceipt}
                          onDataChange={refreshData}
                          mcPermissions={mcPermissions}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            )}
          </Form>
        </Col>
      </Row>
    );
  }
  
  // If this is a Material form, render the custom layout
  if (isMaterialForm || (record && record.type === "Material")) {
    // Get the form values for view mode
    const formValues = formRef.getFieldsValue();
    
    return (
      <Row>
        <Col span={24}>
          <Form
            className="ims-doc-fields-form"
            form={formRef}
            onFinish={onFinish}
            layout="vertical"
          >
          <Row gutter={[20, 10]}>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="AREA NAME *" name="areaName" rules={[{ required: true, message: "Please enter Area Name" }]}>
                  <Input placeholder="Area Name" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">AREA NAME</div>
                  <div className="view-field-value">{formValues.areaName || record.areaName || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="ORIGINAL PRIORITY *" name="originalPriorityId" rules={[{ required: true, message: "Please select Original Priority" }]}>
                  <Select placeholder="Select Priority" loading={fetchPrioritiesLoading}>
                    {projectPriorities && projectPriorities.length > 0 && (
                      projectPriorities.map((priority) => (
                        <Select.Option key={priority.id} value={priority.id}>
                          {priority.name}
                        </Select.Option>
                      ))
                    )}
                  </Select>
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">ORIGINAL PRIORITY</div>
                  <div className="view-field-value">
                    {(() => {
                      const priorityId = formValues.originalPriorityId || record.originalPriorityId;
                      const priority = projectPriorities?.find(p => p.id === priorityId);
                      return priority ? priority.name : '-';
                    })()}
                  </div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="NEW PRIORITY" name="newPriorityId">
                  <Select placeholder="Select Priority" loading={fetchPrioritiesLoading}>
                    {projectPriorities && projectPriorities.length > 0 && (
                      projectPriorities.map((priority) => (
                        <Select.Option key={priority.id} value={priority.id}>
                          {priority.name}
                        </Select.Option>
                      ))
                    )}
                  </Select>
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">NEW PRIORITY
                    {!priorityEditMode && mcPermissions?.edit?.newPriority && (
                      <span 
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                        onClick={() => setPriorityEditMode(true)}
                      >
                        <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                      </span>
                    )}
                  </div>
                  <div className="view-field-value">
                    {priorityEditMode ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Select
                          style={{ width: '80%' }}
                          placeholder="Select priority"
                          value={selectedPriority || formValues.newPriorityId || record.newPriorityId}
                          onChange={(value) => {
                            // Just store the selected value
                            setSelectedPriority(value);
                          }}
                          size="small"
                        >
                          {projectPriorities?.map((priority) => (
                            <Select.Option key={priority.id} value={priority.id}>
                              {priority.name}
                            </Select.Option>
                          ))}
                        </Select>
                        <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                          <SaveOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              // Save the selected value
                              const value = selectedPriority || formValues.newPriorityId || record.newPriorityId;
                              // Update the form values
                              const updatedValues = { ...formValues, newPriorityId: value };
                              setFormValues(updatedValues);
                              
                              // Update the form in Redux
                              if (formRef && formRef.current) {
                                formRef.current.setFieldsValue({ newPriorityId: value });
                              }
                              
                              // Make API call to update the record
                              updateMaterialControlRecord({ newPriorityId: value });
                              
                              // Reset selected priority and exit edit mode
                              setSelectedPriority(null);
                              setPriorityEditMode(false);

                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                          <CloseOutlined 
                            onClick={() => {
                              // Reset selected priority and exit edit mode without saving
                              setSelectedPriority(null);
                              setPriorityEditMode(false);
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                        </div>
                      </div>
                    ) : (
                      (() => {
                        const priorityId = formValues.newPriorityId || record.newPriorityId;
                        const priority = projectPriorities?.find(p => p.id === priorityId);
                        return priority ? priority.name : '-';
                      })()
                    )}
                  </div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="UNIT SUBTOTAL / NET *" name="unitSubtotal" rules={[{ required: true, message: "Please enter Unit Subtotal" }]}>
                  <Input placeholder="Unit Subtotal / Net" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">UNIT SUBTOTAL / NET</div>
                  <div className="view-field-value">{(formValues.unitSubtotal || record.unitSubtotal) ? `${formValues.unitSubtotal || record.unitSubtotal}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : '-'}</div>
                  </div>
              )}
            </Col>
          </Row>
          <Row gutter={[20, 10]}>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="MODEL" name="model">
                  <Input placeholder="Model" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">MODEL</div>
                  <div className="view-field-value">{formValues.model || record.model || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="PROFILE / MEMBER *" name="profileMember" rules={[{ required: true, message: "Please enter Profile/Member" }]}>
                  <Input placeholder="Profile / Member" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">PROFILE / MEMBER</div>
                  <div className="view-field-value">{formValues.profileMember || record.profileMember || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="MATERIAL SPEC *" name="materialSpec" rules={[{ required: true, message: "Please enter Material Spec" }]}>
                  <Input placeholder="Material Spec" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">MATERIAL SPEC</div>
                  <div className="view-field-value">{formValues.materialSpec || record.materialSpec || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="LENGTH (mm) *" name="length" rules={[{ required: true, message: "Please enter Length" }]}>
                  <Input placeholder="Length" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">LENGTH (mm)</div>
                  <div className="view-field-value">{formValues.length || record.length || '-'}</div>
                </div>
              )}
            </Col>
          </Row>
          <Row gutter={[20, 10]}>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="PAINT AREA EACH (m²)" name="paintArea">
                  <Input placeholder="Paint Area Each" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">PAINT AREA EACH (m²)</div>
                  <div className="view-field-value">{formValues.paintArea || record.paintArea || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="SUPPLIER *" name="supplierId" rules={[{ required: true, message: "Please select Supplier" }]}>
                  <Select placeholder="Select Supplier" loading={suppliersLoading}>
                    {allSuppliers && allSuppliers.map(supplier => (
                      <Select.Option key={supplier.id} value={supplier.id}>{supplier.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">SUPPLIER</div>
                  <div className="view-field-value">
                    {(() => {
                      const supplierId = formValues.supplierId || record.supplierId;
                      const supplier = allSuppliers?.find(s => s.id === supplierId);
                      return supplier ? supplier.name : '-';
                    })()}
                  </div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="COMMODITY *" name="commodityId" rules={[{ required: true, message: "Please select Commodity" }]}>
                  <Select placeholder="Select Commodity" loading={commoditiesLoading}>
                    {allCommodities && allCommodities.map(commodity => (
                      <Select.Option key={commodity.id} value={commodity.id}>{commodity.name}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">COMMODITY</div>
                  <div className="view-field-value">
                    {(() => {
                      const commodityId = formValues.commodityId || record.commodityId;
                      const commodity = allCommodities?.find(c => c.id === commodityId);
                      return commodity ? commodity.name : '-';
                    })()}
                  </div>
                </div>
              )}
            </Col>
            <Col span={6}>
              <div className="view-field-container">
                <div className="view-field-label">ATTACHMENTS</div>
                <div className="view-field-value">
                  <AttachmentContainer
                    onUpdate={refreshData}
                    color="#f25003"
                    record={record}
                    recordType="material_control_register"
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row gutter={[20, 10]}>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="COMMENTS" name="comments">
                  <Input placeholder="Comments" />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">COMMENTS
                  {!commentsEditMode && mcPermissions?.edit?.comments && (
                    <span 
                      style={{ marginLeft: '5px', cursor: 'pointer' }}
                      onClick={() => {
                        setCommentsEditMode(true);
                        setEditedComments(formValues.comments || record.comments || '');
                      }}
                    >
                      <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                    </span>
                  )}
                  </div>
                  <div className="view-field-value">
                    {commentsEditMode ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Input
                          style={{ width: '80%' }}
                          placeholder="Enter comments"
                          value={editedComments}
                          onChange={(e) => setEditedComments(e.target.value)}
                          size="small"
                        />
                        <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                          <SaveOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              
                              // Update the form values
                              const updatedValues = { ...formValues, comments: editedComments };
                              setFormValues(updatedValues);
                              
                              // Update the form in Redux
                              if (formRef && formRef.current) {
                                formRef.current.setFieldsValue({ comments: editedComments });
                              }
                              
                              // Make API call to update the record
                              updateMaterialControlRecord({ comments: editedComments });
                              
                              // Exit edit mode
                              setCommentsEditMode(false);
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                          <CloseOutlined 
                            onClick={() => {
                              // Exit edit mode without saving
                              setCommentsEditMode(false);
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                        </div>
                      </div>
                    ) : (
                      formValues.comments || record.comments || '-'
                    )}
                  </div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="STATUS *" name="status" rules={[{ required: true, message: "Please select Status" }]}>
                  <Select placeholder="Select Status">
                    <Select.Option value="Active">Active</Select.Option>
                    <Select.Option value="On Hold">On Hold</Select.Option>
                  </Select>
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="view-field-label">STATUS
                  {!statusEditMode && mcPermissions?.edit?.status && (
                    <span 
                      style={{ marginLeft: '5px', cursor: 'pointer' }}
                      onClick={() => {
                        setStatusEditMode(true);
                        setSelectedStatus(formValues.status || record.status || null);
                        // If status is On Hold, also set onHoldReason edit mode
                        if ((formValues.status || record.status) === 'On Hold') {
                          setOnHoldReasonEditMode(true);
                          setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                        }
                      }}
                    >
                      <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                    </span>
                  )}
                  </div>
                  <div className="view-field-value">
                    {statusEditMode ? (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Select
                          style={{ width: '80%' }}
                          placeholder="Select status"
                          value={selectedStatus || formValues.status || record.status}
                          onChange={(value) => {
                            setSelectedStatus(value);
                            // If changing to On Hold, enable onHoldReason edit mode
                            if (value === 'On Hold') {
                              setOnHoldReasonEditMode(true);
                              setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                            }
                            // If changing from On Hold to something else, reset onHoldReason edit mode
                            else if (onHoldReasonEditMode) {
                              setOnHoldReasonEditMode(false);
                            }
                          }}
                          size="small"
                        >
                          <Select.Option value="Active">Active</Select.Option>
                          <Select.Option value="On Hold">On Hold</Select.Option>
                        </Select>
                        <div style={{ marginLeft: '8px', display: 'flex', gap: '8px' }}>
                          <SaveOutlined 
                            onClick={(e) => {
                              e.stopPropagation();
                              
                              // Get the selected value
                              const value = selectedStatus || formValues.status || record.status;
                              
                              // Update the form values
                              const updatedValues = { ...formValues, status: value };
                              setFormValues(updatedValues);
                              
                              // Update the form in Redux
                              if (formRef && formRef.current) {
                                formRef.current.setFieldsValue({ status: value });
                              }
                              
                              // Make API call to update the record
                              // If status is On Hold, also save the reason
                              if (value === 'On Hold') {
                                // Validate input if status is On Hold
                                if (!editedOnHoldReason.trim()) {
                                  message.error('Please provide a reason for putting on hold');
                                  return;
                                }
                                updateMaterialControlRecord({ 
                                  status: value,
                                  onHoldReason: editedOnHoldReason,
                                  onHoldAt: moment().format("YYYY-MM-DD HH:mm:ss"),
                                  onHoldById: currentUser?.id
                                });
                              } else {
                                updateMaterialControlRecord({ status: value });
                              }
                              
                              // Reset selected status and exit edit mode
                              setSelectedStatus(null);
                              setStatusEditMode(false);
                              // Also reset onHoldReason edit mode if it's active
                              if (onHoldReasonEditMode) {
                                setOnHoldReasonEditMode(false);
                              }
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                          <CloseOutlined 
                            onClick={() => {
                              // Reset selected status and exit edit mode without saving
                              setSelectedStatus(null);
                              setStatusEditMode(false);
                              // Also reset onHoldReason edit mode if it's active
                              if (onHoldReasonEditMode) {
                                setOnHoldReasonEditMode(false);
                              }
                            }} 
                            style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                          />
                        </div>
                      </div>
                    ) : (
                      formValues.status || record.status || '-'
                    )}
                  </div>
                </div>
              )}
            </Col>
            {/* Conditional On Hold Reason field - only show when status is On Hold */}
            {isEditing && (
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => prevValues.status !== currentValues.status}
              >
                {({ getFieldValue }) => {
                  const currentStatus = getFieldValue('status') || formValues.status || record.status;
                  return currentStatus === 'On Hold' ? (
                    <Col span={6}>
                      <Form.Item
                        label="ON HOLD REASON *"
                        name="onHoldReason"
                        rules={[{ required: true, message: "Please provide reason for putting on hold" }]}
                      >
                        <Input.TextArea 
                          style={{ marginTop: '10px' }}
                          placeholder="Enter reason for putting this item on hold"
                          rows={3}
                        />
                      </Form.Item>
                    </Col>
                  ) : null;
                }}
              </Form.Item>
            )}
            {(!isEditing && ((formValues.status === 'On Hold' || record.status === 'On Hold') || (statusEditMode && selectedStatus === 'On Hold'))) && (
              <Col span={6}>
                <div className="view-field-container">
                  <div className="view-field-label" style={{ marginBottom: '8px' }}>ON HOLD REASON *
                    {!onHoldReasonEditMode && statusEditMode && ((formValues.status === 'On Hold' || record.status === 'On Hold' || selectedStatus === 'On Hold')) && mcPermissions?.edit?.status && (
                      <span 
                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                        onClick={() => {
                          setOnHoldReasonEditMode(true);
                          setEditedOnHoldReason(formValues.onHoldReason || record.onHoldReason || '');
                        }}
                      >
                        <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                      </span>
                    )}
                  </div>
                  <div className="view-field-value">
                    {onHoldReasonEditMode ? (
                      <Form.Item
                        style={{ marginBottom: 0 }}
                      >
                        <Input.TextArea
                          value={editedOnHoldReason}
                          onChange={(e) => setEditedOnHoldReason(e.target.value)}
                          style={{ maxWidth: '100%' }}
                          rows={2}
                        />
                      </Form.Item>
                    ) : (
                      formValues.onHoldReason || record.onHoldReason || '-'
                    )}
                  </div>
                </div>
              </Col>
            )}
            {(!isEditing && ((formValues.status === 'On Hold' || record.status === 'On Hold') || (statusEditMode && selectedStatus === 'On Hold'))) && (
              <Col span={6}>
                <div className="view-field-container">
                  <div className="view-field-label">ON HOLD DETAILS</div>
                  <div className="view-field-value">
                    <div>Date: {statusEditMode && selectedStatus === 'On Hold' ? moment().format("DD MMM YYYY") : (record.onHoldAt ? moment(record.onHoldAt).format("DD MMM YYYY") : '-')}</div>
                    <div>Changed By: {statusEditMode && selectedStatus === 'On Hold' ? (currentUser && `${currentUser.firstName} ${currentUser.lastName}`) : (onHoldUser ? `${onHoldUser.firstName} ${onHoldUser.lastName}` : '-')}</div>
                  </div>
                </div>
              </Col>
            )}
          </Row>
          <div className="created-modified-field-group">
          <Row gutter={[20, 10]}>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="CREATED BY" name="createdById">
                  <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="created-modified-field-label">CREATED BY</div>
                  <div className="created-modified-field-value">{ record.createdBy ? `${record.createdBy.firstName} ${record.createdBy.lastName}` : formValues.createdById || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="CREATED DATE & TIME" name="createdDate">
                  <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="created-modified-field-label">CREATED DATE & TIME</div>
                  <div className="created-modified-field-value">{formValues.createdDate || (record.createdAt ? moment(record.createdAt).format("DD MMM YYYY HH:mm") : '-')}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="MODIFIED BY" name="updatedById">
                  <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="created-modified-field-label">MODIFIED BY</div>
                  <div className="created-modified-field-value">{ formValues.updatedBy && formValues.updatedBy.firstName + " " + formValues.updatedBy.lastName ||record.updatedById && updatedBy && `${updatedBy.firstName} ${updatedBy.lastName}` || '-'}</div>
                </div>
              )}
            </Col>
            <Col span={6}>
              {isEditing ? (
                <Form.Item label="MODIFIED DATE & TIME" name="modifiedDate">
                  <Input disabled style={{ border: 'none', background: 'transparent', padding: 0 }} />
                </Form.Item>
              ) : (
                <div className="view-field-container">
                  <div className="created-modified-field-label">MODIFIED DATE & TIME</div>
                  <div className="created-modified-field-value">{formValues.modifiedDate || (record.updatedAt ? moment(record.updatedAt).format("DD MMM YYYY HH:mm") : '-') || '-'}</div>
                </div>
              )}
            </Col>
          </Row>
          </div>
          {/* Dynamic fields from template */}
          {fields.filter(field => ![
            'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'model', 'profileMember',
            'materialSpec', 'length', 'paintArea', 'supplierId', 'commodityId', 'attachments', 'comments',
            'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
          ].includes(field.id)).length > 0 && (
            <>
              <Row>
                <Col span={24}>
                  <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                </Col>
              </Row>
              <Row gutter={[20, 10]} style={{ position: 'relative' }}>
                {!isEditing && (
                  <div style={{ position: 'absolute', top: '5px', right: '20px', zIndex: 1 }}>
                    {dynamicFieldsEditMode ? (
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <SaveOutlined 
                          onClick={() => {
                            // Save all dynamic field values
                            const updateData = {};
                            
                            // Create materialTemplateFields object with all edited values as strings
                            Object.keys(dynamicFieldValues).forEach(fieldId => {
                              // Convert all values to strings to ensure consistency
                              updateData[fieldId] = dynamicFieldValues[fieldId] !== null && dynamicFieldValues[fieldId] !== undefined ? String(dynamicFieldValues[fieldId]) : '';
                            });
                            
                            // Update form values
                            const updatedFormValues = { ...formValues };
                            Object.keys(dynamicFieldValues).forEach(fieldId => {
                              updatedFormValues[fieldId] = dynamicFieldValues[fieldId];
                            });
                            setFormValues(updatedFormValues);
                            
                            // Update Redux form
                            if (formRef && formRef.current) {
                              formRef.current.setFieldsValue(dynamicFieldValues);
                            }
                            
                            // Make API call to update the record
                            if (Object.keys(updateData).length > 0) {
                              updateMaterialControlRecord({
                                materialTemplateFields: updateData
                              });
                            }
                            
                            // Exit edit mode
                            setDynamicFieldsEditMode(false);
                          }} 
                          style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                        />
                        <CloseOutlined 
                          onClick={() => {
                            // Exit edit mode without saving
                            setDynamicFieldsEditMode(false);
                            // Reset dynamic field values
                            setDynamicFieldValues({});
                          }} 
                          style={{ fontSize: '16px', color: '#f25003', cursor: 'pointer' }} 
                        />
                      </div>
                    ) : (
                      mcPermissions?.edit?.template_fields && (
                        <span 
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            // Enter edit mode
                            setDynamicFieldsEditMode(true);
                            
                            // Initialize dynamic field values with current values
                            const initialValues = {};
                            fields.filter(field => ![
                              'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'model', 'profileMember',
                              'materialSpec', 'length', 'paintArea', 'supplierId', 'commodityId', 'attachments', 'comments',
                              'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                            ].includes(field.id)).forEach(field => {
                              initialValues[field.id] = formValues[field.id] || 
                                (record.materialTemplateFields && record.materialTemplateFields[field.id]) || '';
                            });
                            setDynamicFieldValues(initialValues);
                          }}
                        >
                          <EditOutlined style={{ fill: '#f25003', width: '16px', height: '16px', fontSize: '16px' }} />
                        </span>
                      )
                    )}
                  </div>
                )}
                {fields.filter(field => ![
                  'areaName', 'originalPriorityId', 'newPriorityId', 'unitSubtotal', 'model', 'profileMember',
                  'materialSpec', 'length', 'paintArea', 'supplierId', 'commodityId', 'attachments', 'comments',
                  'status', 'createdById', 'createdDate', 'updatedById', 'modifiedDate'
                ].includes(field.id)).map(field => {
                  const { id, name, field_type, field_options } = field;
                  
                  // Format the value based on field type for display
                  let displayValue = formValues[id] || (record.materialTemplateFields && record.materialTemplateFields[id]) || '-';
                  
                  if (field_type === "select_field" && field_options && Array.isArray(field_options)) {
                    // Parse the value to integer if it's a numeric string
                    if (typeof displayValue === 'string' && !isNaN(displayValue)) {
                      displayValue = parseInt(displayValue);
                    }
                    const option = field_options.find(opt => opt.id === displayValue || opt.value === displayValue);
                    displayValue = option ? option.name : displayValue;
                  } else if (field_type === "date_field" && displayValue && displayValue !== '-') {
                    try {
                      displayValue = moment(displayValue).format('DD MMM YYYY');
                    } catch (e) {
                      // If date parsing fails, use the original value
                    }
                  }
                  
                  return (
                    <Col span={6} key={id}>
                      {isEditing ? (
                        renderFormItem(field)
                      ) : (
                        <div className="view-field-container">
                          <div className="view-field-label">{name}</div>
                          <div className="view-field-value">
                            {dynamicFieldsEditMode ? (
                              field_type === "select_field" ? (
                                <Select
                                  style={{ width: '100%', maxWidth: '200px' }}
                                  placeholder={`Select ${name}`}
                                  value={dynamicFieldValues[id]}
                                  onChange={(value) => setDynamicFieldValues(prev => ({ ...prev, [id]: value }))}
                                  size="small"
                                  dropdownMatchSelectWidth={false}
                                >
                                  {field_options && Array.isArray(field_options) && field_options.map(option => (
                                    <Select.Option key={option.id || option.value} value={option.id || option.value}>
                                      {option.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              ) : field_type === "date_field" ? (
                                <div className="custom-datepicker-wrapper">
                                  <DatePicker
                                    style={{ width: '100%', maxWidth: '200px' }}
                                    value={dynamicFieldValues[id] ? moment(dynamicFieldValues[id]) : null}
                                    onChange={(date) => setDynamicFieldValues(prev => ({ ...prev, [id]: date ? date.format('YYYY-MM-DD') : null }))}
                                    // disabledDate={disabledDate}
                                    size="small"
                                    format="DD MMM YYYY"
                                    suffixIcon={null}
                                  />
                                </div>
                              ) : (
                                <Input
                                  style={{ width: '100%', maxWidth: '200px' }}
                                  value={dynamicFieldValues[id]}
                                  onChange={(e) => setDynamicFieldValues(prev => ({ ...prev, [id]: e.target.value }))}
                                  size="small"
                                />
                              )
                            ) : (
                              displayValue
                            )}
                          </div>
                        </div>
                      )}
                    </Col>
                  );
                })}
              </Row>
              <Row>
                <Col span={24}>
                  <div style={{ borderBottom: '1px solid #d9d9d9', marginBottom: '10px', marginTop: '5px' }}></div>
                </Col>
              </Row>
            </>
          )}
            {/* Only show tracking stages when record has been saved (has an ID and is not in editing mode) */}
            {record && record.id && !isEditing && (
              <Row gutter={[16, 10]} style={{ marginTop: '15px'}}>
                <Col span={4}>
                  <div className="tracking-stage fabrication-stage">
                    <div className="tracking-stage-header">FABRICATION</div>
                    <div className="tracking-stage-status">
                      <div className={`status-badge ${fabrication && fabrication.status === 'completed' ? 'completed' : (fabrication && fabrication.status === 'in_progress' ? 'in-progress' : (fabrication && fabrication.status === 'received' ? 'received' : ''))}`}>
                        {fabrication && fabrication.status ? 
                          fabrication.status === 'in_progress' ? 'In Progress' : 
                          fabrication.status.charAt(0).toUpperCase() + fabrication.status.slice(1) 
                        : 'Not Started'}
                      </div>
                    </div>
                    <div className="field-group mark-recieved">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {datePickerVisible ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              size="small" 
                              className="date-picker-small"
                              onChange={(date) => setSelectedDate(date)}
                              value={selectedDate}
                              suffixIcon={null} /* Hide the default calendar icon */
                              format="DD MMM YYYY" /* Format the date display */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('fabrication')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDatePickerVisible(false);
                                  setQtyInputVisible(false);
                                  setSelectedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (fabrication && fabrication.receivedAt) ? (
                          <div className="saved-date-display">
                            {moment(fabrication.receivedAt).format('DD MMM YYYY')}
                            {mcPermissions?.fabrication?.mark_received && !isProjectOnHold() && (
                              <div className="saved-icons-container">
                                <CheckOutlined className="saved-check-icon" />
                                <div 
                                  onClick={() => {
                                    setDatePickerVisible(true);
                                    setQtyInputVisible(true);
                                  }}
                                  className="edit-date-icon"
                                >
                                  <EditOutlined className="edit-icon" />
                                </div>
                              </div>
                            )}
                          </div>
                        ) : mcPermissions?.fabrication?.mark_received && !isProjectOnHold() && (
                          <div className="tick-box-container">
                            <div 
                              onClick={() => {
                                setDatePickerVisible(true);
                                setQtyInputVisible(true);
                              }}
                              className="tick-box"
                            >
                              <CheckOutlined style={{ fontSize: '16px' }} />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {qtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={receivedQty}
                              onChange={(e) => setReceivedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : qtyIsSaved && receivedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(receivedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {receivedQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={receivedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isAuthorized}
                              type="fabrication"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedLocation}
                              onChange={(value) => setSelectedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qtyIsSaved && selectedLocation ? (
                          <div className="saved-location-display">
                            {allLocations && allLocations.find(loc => loc.id === selectedLocation)?.name || ''}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {updatedByUser || ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {completedDatePickerVisible && mcPermissions?.fabrication?.mark_completed ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              size="small" 
                              className="date-picker-small"
                              onChange={(date) => setSelectedCompletedDate(date)}
                              value={selectedCompletedDate}
                              suffixIcon={null} /* Hide the default calendar icon */
                              format="DD MMM YYYY" /* Format the date display */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('fabrication')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() =>  {
                                  setCompletedDatePickerVisible(false);
                                  setCompletedQtyInputVisible(false);
                                  setSelectedCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (fabrication && fabrication.completedAt) ? (
                          <div className="saved-date-display">
                            {moment(fabrication.completedAt).format('DD MMM YYYY')}
                            {mcPermissions?.fabrication?.mark_completed && !isProjectOnHold() && (
                            <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" />
                              <div 
                                onClick={() => {
                                  setCompletedDatePickerVisible(true);
                                  setCompletedQtyInputVisible(true);
                                }}
                                className="edit-date-icon"
                              >
                                <EditOutlined className="edit-icon" />
                              </div>
                            </div>
                            )}
                          </div>
                        ) : (
                          isItemReceived ? (
                            mcPermissions?.fabrication?.mark_completed && !isProjectOnHold() && 
                            !(needsAuthorization(receivedQty, record.qty, maxAuthorizeValue, false) && !authorizationReceivedData) && (
                            <div className="tick-box-container mark-completed">
                              <div 
                                onClick={() => {
                                  setCompletedDatePickerVisible(true);
                                  setCompletedQtyInputVisible(true);
                                }}
                                className="tick-box"
                              >
                                <CheckOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                            )
                          ) : null
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {completedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={completedQty}
                              onChange={(e) => setCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : completedQtyIsSaved && completedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(completedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {completedQty} of {record.qty || 1}
                            </span>
                            {Number(completedQty) > Number(record.qty || 1) && (
                              <AuthorizeExcess
                                receivedQty={completedQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isCompletedAuthorized}
                                type="fabrication"
                                onAuthorize={handleSaveMarkCompleted}
                                authorizationData={authorizationCompletedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {completedDatePickerVisible ? (
                          <div className="location-container">
                            <Select
                              placeholder="Select Location"
                              style={{ width: '100%' }}
                              size="small"
                              onChange={(value) => setSelectedCompletedLocation(value)}
                              value={selectedCompletedLocation}
                              loading={locationsLoading}
                            >
                              {allLocations?.map((location) => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : completedDateIsSaved && selectedCompletedLocation ? (
                          <div className="saved-location-display">
                            {allLocations?.find(loc => loc.id === selectedCompletedLocation)?.name || 'Unknown Location'}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">
                        {completedByUser || ""}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { grossCompleted ? `${grossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {supplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedSupplierForTracking}
                              onChange={(value) => setSelectedSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('fabrication', fabrication, selectedSupplierForTracking);
                                  setSupplierEditMode(false);
                                }}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSupplierEditMode(false);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.fabrication?.update_supplier && !isProjectOnHold() && (
                            <EditOutlined 
                              onClick={() => {
                                setSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#8e44ad'}} 
                            />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#8e44ad"
                          recordType="fabrication"
                          record={fabrication}
                          canAdd={mcPermissions?.fabrication?.add_attachments}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage qc-release-stage">
                  <div className="tracking-stage-header">QC RELEASE</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${qcRelease && qcRelease.status === 'completed' ? 'completed' : (qcRelease && qcRelease.status === 'in_progress' ? 'in-progress' : (qcRelease && qcRelease.status === 'received' ? 'received' : ''))}`}>
                        {qcRelease && qcRelease.status ? 
                          qcRelease.status === 'in_progress' ? 'In Progress' : 
                          qcRelease.status.charAt(0).toUpperCase() + qcRelease.status.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      {isQCReleaseReady && !qcDatePickerVisible && !qcDateIsSaved ? (
                        mcPermissions?.qc_release?.mark_received && !isProjectOnHold() &&
                        !(needsAuthorization(completedQty, record.qty, maxAuthorizeValue, false)) && (
                        <div className="tick-box-container mark-completed" style={{ color: '#c0392b' }}>
                          <div onClick={() => { 
                            setQcDatePickerVisible(true);
                            setQcQtyInputVisible(true);
                          }} className="tick-box-qc" style={{ color: '#c0392b' }}>
                            <CheckOutlined style={{ color: '#c0392b' }}/>
                          </div>
                        </div>
                        )
                      ) : qcDatePickerVisible && mcPermissions?.qc_release?.mark_received && !isProjectOnHold() ? (
                        <div className="date-picker-container">
                          <DatePicker 
                            className="date-picker-small"
                            value={selectedQcDate}
                            onChange={(date) => setSelectedQcDate(date)}
                            format="DD MMM YYYY"
                            placeholder="Select date"
                            size="small"
                            suffixIcon={null} /* Hide the default calendar icon */
                            disabledDate={disabledDate}
                          />
                          <div className="action-icons-container">
                            <div 
                              onClick={() => handleSaveMarkRecieved('qc_release')}
                              className="action-icon save"
                            >
                              <SaveOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                            </div>
                            <div 
                              onClick={() => {
                                setQcDatePickerVisible(false);
                                setQcQtyInputVisible(false);
                                setSelectedQcDate(null);
                              }}
                              className="action-icon close"
                            >
                              <CloseOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                            </div>
                          </div>
                        </div>
                      ) : (qcRelease && qcRelease.receivedAt) ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(qcRelease.receivedAt).format('DD MMM YYYY')}</span>
                          {mcPermissions?.qc_release?.mark_received && !isProjectOnHold() ? (
                            <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#c0392b' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#c0392b' }} 
                                onClick={() => {
                                  setQcDatePickerVisible(true);
                                  setQcQtyInputVisible(true);
                                }}
                              />
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {qcQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={qcQty}
                                onChange={(e) => setQcQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : qcQtyIsSaved && qcQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(qcQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {qcQty} of {record.qty || 1}
                              </span>
                              <AuthorizeExcess
                                receivedQty={qcQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isQcAuthorized}
                                type="qc_release"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationQcReceivedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qcQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedQcLocation}
                              onChange={(value) => setSelectedQcLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qcDateIsSaved && selectedQcLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedQcLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{qcByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {qcDateIsSaved && !qcCompletedDatePickerVisible && !qcCompletedDateIsSaved && mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(qcQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#c0392b' }}>
                            <div onClick={() => { 
                              setQcCompletedDatePickerVisible(true);
                              setQcCompletedQtyInputVisible(true);
                            }} className="tick-box-completed" style={{ color: '#c0392b' }}>
                              <CheckOutlined style={{ color: '#c0392b' }}/>
                            </div>
                          </div>
                        ) : qcCompletedDatePickerVisible && mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedQcCompletedDate}
                              onChange={(date) => setSelectedQcCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('qc_release')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setQcCompletedDatePickerVisible(false);
                                  setQcCompletedQtyInputVisible(false);
                                  setSelectedQcCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#c0392b' }} />
                              </div>
                            </div>
                          </div>
                        ) : (qcRelease && qcRelease.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(qcRelease.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.qc_release?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#c0392b' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#c0392b' }} 
                                onClick={() => {
                                  setQcCompletedDatePickerVisible(true);
                                  setQcCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          {qcCompletedQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={qcCompletedQty}
                                onChange={(e) => setQcCompletedQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : qcCompletedQtyIsSaved && qcCompletedQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(qcCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {qcCompletedQty} of {record.qty || 1}
                              </span>
                              {Number(qcCompletedQty) > Number(record.qty || 1) && (
                                <AuthorizeExcess
                                  receivedQty={qcCompletedQty}
                                  expectedQty={record.qty || 1}
                                  record={record}
                                  currentUser={currentUser}
                                  isAuthorized={isQcCompletedAuthorized}
                                  type="qc_release"
                                  onAuthorize={handleSaveMarkCompleted}
                                  authorizationData={authorizationQcCompletedData}
                                  maxAuthorizeValue={maxAuthorizeValue}
                                />
                              )}
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {qcCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedQcCompletedLocation}
                              onChange={(value) => setSelectedQcCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : qcCompletedDateIsSaved && selectedQcCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedQcCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{qcCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { qcGrossCompleted ? `${qcGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {qcSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedQcSupplierForTracking}
                              onChange={(value) => setSelectedQcSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('qc_release', qcRelease, selectedQcSupplierForTracking);
                                  setQcSupplierEditMode(false);
                                }}
                                style={{color: '#c0392b'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setQcSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#c0392b'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedQcSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedQcSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.qc_release?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setQcSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#c0392b'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#c0392b"
                          recordType="qc_release"
                          record={qcRelease}
                          canAdd={mcPermissions?.qc_release?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                        <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#c0392b"
                          materialControlRegisterId={record?.id}
                          progressStepType="qc_release"
                          onCountChange={setQcDeliveryNotesCount}
                          projectId={project_id}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-to-workshop-stage">
                  <div className="tracking-stage-header">CORROSION PROT</div>
                  <div className="tracking-stage-status">
                  <div className={`status-badge ${corrosionProtection && corrosionProtection.status === 'completed' ? 'completed' : (corrosionProtection && corrosionProtection.status === 'in_progress' ? 'in-progress' : (corrosionProtection && corrosionProtection.status === 'received' ? 'received' : ''))}`}>
                        {corrosionProtection && corrosionProtection.status ? 
                          corrosionProtection.status === 'in_progress' ? 'In Progress' : 
                          corrosionProtection.status.charAt(0).toUpperCase() + corrosionProtection.status.slice(1) 
                        : 'Not Started'}
                      </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                      {isCorrosionProtectionReady && !corrosionDatePickerVisible && !corrosionDateIsSaved && mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() &&
                      !(needsAuthorization(qcCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                        <div className="tick-box-container mark-completed" style={{ color: '#ffc000'}}>
                          <div onClick={() => { 
                            setCorrosionDatePickerVisible(true);
                            setCorrosionQtyInputVisible(true);
                          }} className="tick-box-cc" style={{ color: '#ffc000' }}>
                            <CheckOutlined style={{ color: '#ffc000' }}/>
                          </div>
                        </div>
                      ) : corrosionDatePickerVisible && mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() ? (
                        <div className="date-picker-container">
                          <DatePicker 
                            className="date-picker-small"
                            value={selectedCorrosionDate}
                            onChange={(date) => setSelectedCorrosionDate(date)}
                            format="DD MMM YYYY"
                            placeholder="Select date"
                            size="small"
                            suffixIcon={null} /* Hide the default calendar icon */
                            disabledDate={disabledDate}
                          />
                          <div className="action-icons-container">
                            <div 
                              onClick={() => handleSaveMarkRecieved('corrosion_protection')}
                              className="action-icon save"
                            >
                              <SaveOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                            </div>
                            <div 
                              onClick={() => {
                                setCorrosionDatePickerVisible(false);
                                setCorrosionQtyInputVisible(false);
                                setSelectedCorrosionDate(null);
                              }}
                              className="action-icon close"
                            >
                              <CloseOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                            </div>
                          </div>
                        </div>
                      ) : corrosionDateIsSaved && selectedCorrosionDate && corrisonSignedDeliveryNote ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{selectedCorrosionDate.format('DD MMM YYYY')}</span>
                          {mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() && <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                            <AttachmentContainer
                              onUpdate={refreshData}
                              color="#ffc000"
                              recordType="corrosion_protection"
                              additionalData="signedDeliveryNote"
                              visibility={true}
                              record={corrosionProtection}
                            />
                            <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                            <EditOutlined 
                              className="edit-icon" 
                              style={{ fill: '#ffc000' }} 
                              onClick={() => {
                                setCorrosionDatePickerVisible(true);
                                setCorrosionQtyInputVisible(true);
                              }}
                            />
                          </div>}
                        </div>
                      ) : (corrosionProtection && corrosionProtection.receivedAt) ? (
                        <div className="saved-supplier-display">
                          <span className="supplier-name">{moment(corrosionProtection.receivedAt).format('DD MMM YYYY')}</span>
                          {mcPermissions?.corrosion_protection?.mark_received && !isProjectOnHold() && <div className="saved-icons-container" style={{ color: '#ffc000' }}>
                            <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                            <EditOutlined 
                              className="edit-icon" 
                              style={{ fill: '#ffc000' }} 
                              onClick={() => {
                                setCorrosionDatePickerVisible(true);
                                setCorrosionQtyInputVisible(true);
                              }}
                            />
                          </div>}
                        </div>
                      ) : null}
                      </div>
                    </div>
                    {corrosionQtyInputVisible ? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#ffc000"
                          recordType="corrosion_protection"
                          additionalData="signedDeliveryNote"
                          record={corrosionProtection}
                          onAttachmentCountChange={(count) => {
                            setCorrisonSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                        )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                          {corrosionQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={corrosionQty}
                                onChange={(e) => setCorrosionQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : corrosionQtyIsSaved && corrosionQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(corrosionQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {corrosionQty} of {record.qty || 1}
                              </span>
                              <AuthorizeExcess
                                receivedQty={corrosionQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isCorrosionAuthorized}
                                type="corrosion_protection"
                                onAuthorize={handleSaveMarkRecieved}
                                authorizationData={authorizationCorrosionReceivedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {corrosionQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedCorrosionLocation}
                              onChange={(value) => setSelectedCorrosionLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : corrosionDateIsSaved && selectedCorrosionLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedCorrosionLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{corrosionByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {corrosionDateIsSaved && !corrosionCompletedDatePickerVisible && !corrosionCompletedDateIsSaved && mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(corrosionQty, record.qty, maxAuthorizeValue, isCorrosionCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#ffc000' }}>
                            <div onClick={() => { 
                              setCorrosionCompletedDatePickerVisible(true);
                              setCorrosionCompletedQtyInputVisible(true);
                            }} className="tick-box-cc" style={{ color: '#ffc000' }}>
                              <CheckOutlined style={{ color: '#ffc000' }}/>
                            </div>
                          </div>
                        ) : corrosionCompletedDatePickerVisible && mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedCorrosionCompletedDate}
                              onChange={(date) => setSelectedCorrosionCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('corrosion_protection')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setCorrosionCompletedDatePickerVisible(false);
                                  setCorrosionCompletedQtyInputVisible(false);
                                  setSelectedCorrosionCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#ffc000' }} />
                              </div>
                            </div>
                          </div>
                        ) : (corrosionProtection && corrosionProtection.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(corrosionProtection.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.corrosion_protection?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#ffc000' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#ffc000' }} 
                                onClick={() => {
                                  setCorrosionCompletedDatePickerVisible(true);
                                  setCorrosionCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                     <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                          {corrosionCompletedQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={corrosionCompletedQty}
                                onChange={(e) => setCorrosionCompletedQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : corrosionCompletedQtyIsSaved && corrosionCompletedQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(corrosionCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {corrosionCompletedQty} of {record.qty || 1}
                              </span>
                              {Number(corrosionCompletedQty) > Number(record.qty || 1) && (
                                <AuthorizeExcess
                                  receivedQty={corrosionCompletedQty}
                                  expectedQty={record.qty || 1}
                                  record={record}
                                  currentUser={currentUser}
                                  isAuthorized={isCorrosionCompletedAuthorized}
                                  type="corrosion_protection"
                                  onAuthorize={handleSaveMarkCompleted}
                                  authorizationData={authorizationCorrosionCompletedData}
                                  maxAuthorizeValue={maxAuthorizeValue}
                                />
                              )}
                              </div>
                          ) : (
                            <div></div>
                          )}
                      </div>
                    </div>
                     <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {corrosionCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedCorrosionCompletedLocation}
                              onChange={(value) => setSelectedCorrosionCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : corrosionCompletedDateIsSaved && selectedCorrosionCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedCorrosionCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{corrosionCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        { corrosionGrossCompleted ? `${corrosionGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {corrosionSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedCorrosionSupplierForTracking}
                              onChange={(value) => setSelectedCorrosionSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('corrosion_protection', corrosionProtection, selectedCorrosionSupplierForTracking);
                                  setCorrosionSupplierEditMode(false);
                                }}
                                style={{color: '#ffc000'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setCorrosionSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#ffc000'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedCorrosionSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedCorrosionSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.corrosion_protection?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setCorrosionSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#ffc000'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#ffc000"
                          recordType="corrosion_protection"
                          record={corrosionProtection}
                          canAdd={mcPermissions?.corrosion_protection?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field delivery-notes-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                         <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#ffc000"
                          materialControlRegisterId={record?.id}
                          progressStepType="corrosion_protection"
                          onCountChange={setCorrosionDeliveryNotesCount}
                          projectId={project_id}
                        />
                        </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage delivery-stage">
                  <div className="tracking-stage-header">DELIVERY TO SITE</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${deliveryToSite && deliveryToSite.status === 'completed' ? 'completed' : (deliveryToSite && deliveryToSite.status === 'in_progress' ? 'in-progress' : (deliveryToSite && deliveryToSite.status === 'received' ? 'received' : ''))}`}>
                      {deliveryToSite && deliveryToSite.status ? 
                        deliveryToSite.status === 'in_progress' ? 'In Progress' : 
                        deliveryToSite.status.charAt(0).toUpperCase() + deliveryToSite.status.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {isDeliveryToSiteReady && !deliveryDatePickerVisible && !deliveryDateIsSaved && mcPermissions?.delivery?.mark_received && !isProjectOnHold() &&
                        !(needsAuthorization(corrosionCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#3498db' }}>
                            <div onClick={() => { 
                              setDeliveryDatePickerVisible(true);
                              setDeliveryQtyInputVisible(true);
                            }} className="tick-box-dts" style={{ color: '#3498db' }}>
                              <CheckOutlined style={{ color: '#3498db' }}/>
                            </div>
                          </div>
                        ) : deliveryDatePickerVisible && mcPermissions?.delivery?.mark_received && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedDeliveryDate}
                              onChange={(date) => setSelectedDeliveryDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('delivery_to_site')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(false);
                                  setDeliveryQtyInputVisible(false);
                                  setSelectedDeliveryDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                            </div>
                          </div>
                        ) : (deliveryToSite && deliveryToSite.receivedAt) && deliveryToSiteSignedDeliveryNote ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <AttachmentContainer
                                onUpdate={refreshData}
                                color="#3498db"
                                recordType="delivery_to_site"
                                additionalData="signedDeliveryNote"
                                visibility={true}
                                record={deliveryToSite}
                              />
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(true);
                                  setDeliveryQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : (deliveryToSite && deliveryToSite.receivedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryDatePickerVisible(true);
                                  setDeliveryQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {deliveryQtyInputVisible? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#3498db"
                          recordType="delivery_to_site"
                          additionalData="signedDeliveryNote"
                          record={deliveryToSite}
                          onAttachmentCountChange={(count) => {
                            setDeliveryToSiteSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                        )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {deliveryQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={deliveryQty}
                              onChange={(e) => setDeliveryQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : deliveryQtyIsSaved && deliveryQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(deliveryQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {deliveryQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={deliveryQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isDeliveryAuthorized}
                              type="delivery_to_site"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliveryReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {deliveryQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedDeliveryLocation}
                              onChange={(value) => setSelectedDeliveryLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : deliveryDateIsSaved && selectedDeliveryLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedDeliveryLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{deliveryByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {deliveryDateIsSaved && !deliveryCompletedDatePickerVisible && !deliveryCompletedDateIsSaved && mcPermissions?.delivery?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(deliveryQty, record.qty, maxAuthorizeValue, isDeliveryCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#3498db' }}>
                            <div onClick={() => { 
                              setDeliveryCompletedDatePickerVisible(true);
                              setDeliveryCompletedQtyInputVisible(true);
                            }} className="tick-box-dts" style={{ color: '#3498db' }}>
                              <CheckOutlined style={{ color: '#3498db' }}/>
                            </div>
                          </div>
                        ) : deliveryCompletedDatePickerVisible && mcPermissions?.delivery?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedDeliveryCompletedDate}
                              onChange={(date) => setSelectedDeliveryCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('delivery_to_site')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliveryCompletedDatePickerVisible(false);
                                  setDeliveryCompletedQtyInputVisible(false);
                                  setSelectedDeliveryCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#3498db' }} />
                              </div>
                            </div>
                          </div>
                        ) : (deliveryToSite && deliveryToSite.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(deliveryToSite.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.delivery?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#3498db' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#3498db' }} 
                                onClick={() => {
                                  setDeliveryCompletedDatePickerVisible(true);
                                  setDeliveryCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {deliveryCompletedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={deliveryCompletedQty}
                              onChange={(e) => setDeliveryCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : deliveryCompletedQtyIsSaved && deliveryCompletedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(deliveryCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {deliveryCompletedQty} of {record.qty || 1}
                            </span>
                            {Number(deliveryCompletedQty) > Number(record.qty || 1) && (
                              <AuthorizeExcess
                                receivedQty={deliveryCompletedQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isDeliveryCompletedAuthorized}
                                type="delivery_to_site"
                                onAuthorize={handleSaveMarkCompleted}
                                authorizationData={authorizationDeliveryCompletedData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            )}
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {deliveryCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedDeliveryCompletedLocation}
                              onChange={(value) => setSelectedDeliveryCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : deliveryCompletedDateIsSaved && selectedDeliveryCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedDeliveryCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{deliveryCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {deliveryGrossCompleted ? `${deliveryGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                      <div className="field-value">
                        {siteReceiptSupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedSiteReceiptSupplierForTracking}
                              onChange={(value) => setSelectedSiteReceiptSupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('site_receipt', siteReceipt, selectedSiteReceiptSupplierForTracking);
                                  setSiteReceiptSupplierEditMode(false);
                                }}
                                style={{color: '#3498db'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptSupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#3498db'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedSiteReceiptSupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedSiteReceiptSupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.delivery?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setSiteReceiptSupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#3498db'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#3498db"
                          recordType="delivery_to_site"
                          record={deliveryToSite}
                          canAdd={mcPermissions?.delivery?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">DELIVERY NOTES #</div>
                      <div className="field-value">
                         <DeliveryNotesList
                          onUpdate={refreshData} 
                          color="#3498db"
                          materialControlRegisterId={record?.id}
                          progressStepType="delivery_to_site"
                          onCountChange={setDeliveryToSiteDeliveryNotesCount}
                          projectId={project_id}
                        />
                        </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage receipt-stage">
                  <div className="tracking-stage-header">SITE RECEIPT</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${siteReceipt && siteReceipt.status === 'completed' ? 'completed' : (siteReceipt && siteReceipt.status === 'in_progress' ? 'in-progress' : (siteReceipt && siteReceipt.status === 'received' ? 'received' : ''))}`}>
                      {siteReceipt && siteReceipt.status ? 
                        siteReceipt.status === 'in_progress' ? 'In Progress' : 
                        siteReceipt.status.charAt(0).toUpperCase() + siteReceipt.status.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                  <div className="field-group mark-received">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE RECEIVED</div>
                      <div className="field-value">
                        {isDeliveryItemCompleted && !siteReceiptDatePickerVisible && !siteReceiptDateIsSaved && mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() &&
                        !(needsAuthorization(deliveryCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#f5a44d' }}>
                            <div onClick={() => { 
                              setSiteReceiptDatePickerVisible(true);
                              setSiteReceiptQtyInputVisible(true);
                            }} className="tick-box-sr" style={{ color: '#f5a44d' }}>
                              <CheckOutlined style={{ color: '#f5a44d' }}/>
                            </div>
                          </div>
                        ) : siteReceiptDatePickerVisible && mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedSiteReceiptDate}
                              onChange={(date) => setSelectedSiteReceiptDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkRecieved('site_receipt')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptDatePickerVisible(false);
                                  setSiteReceiptQtyInputVisible(false);
                                  setSelectedSiteReceiptDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                            </div>
                          </div>
                        ) : (siteReceipt && siteReceipt.receivedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(siteReceipt.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <AttachmentContainer
                                onUpdate={refreshData}
                                color="#f5a44d"
                                recordType="site_receipt"
                                additionalData="signedDeliveryNote"
                                visibility={true}
                                record={siteReceipt}
                              />  
                              <CheckOutlined className="saved-check-icon" style={{ color: '#f5a44d' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#f5a44d' }} 
                                onClick={() => {
                                  setSiteReceiptDatePickerVisible(true);
                                  setSiteReceiptQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) :  (siteReceipt && siteReceipt.receivedAt) && siteReceiptSignedDeliveryNote ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(siteReceipt.receivedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.site_receipt?.mark_received && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#f5a44d' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#f5a44d' }} 
                                onClick={() => {
                                  setSiteReceiptDatePickerVisible(true);
                                  setSiteReceiptQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {siteReceiptQtyInputVisible ? ( 
                    <div className="tracking-stage-field">
                    <div className="field-label">SIGNED DELIVERY NOTE</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#f5a44d"
                          recordType="site_receipt"
                          additionalData="signedDeliveryNote"
                          record={siteReceipt}
                          onAttachmentCountChange={(count) => {
                            setSiteReceiptSignedDeliveryNote(count >= 1);
                          }}
                          onLocalAttachmentsChange={(attachments) => {
                            setLocalSignedDeliveryNoteAttachments(attachments);
                            setCorrisonSignedDeliveryNote(attachments.length >= 1);
                          }}
                        />
                      </div>
                    </div>
                    ) : (
                            <div></div>
                        )}
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY RECEIVED</div>
                      <div className="field-value">
                        {siteReceiptQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={siteReceiptQty}
                              onChange={(e) => setSiteReceiptQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : siteReceiptQtyIsSaved && siteReceiptQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(siteReceiptQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {siteReceiptQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={siteReceiptQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkRecieved}
                              authorizationData={authorizationDeliverytoSiteReceivedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {siteReceiptQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedSiteReceiptLocation}
                              onChange={(value) => setSelectedSiteReceiptLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : siteReceiptDateIsSaved && selectedSiteReceiptLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedSiteReceiptLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{siteReceiptByUser}</div>
                    </div>
                  </div>
                  <div className="field-group mark-completed">
                    <div className="tracking-stage-field">
                      <div className="field-label">DATE COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptDateIsSaved && !siteReceiptCompletedDatePickerVisible && !siteReceiptCompletedDateIsSaved && mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() &&
                        !(needsAuthorization(siteReceiptQty, record.qty, maxAuthorizeValue, isSiteReceiptCompletedAuthorized)) ? (
                          <div className="tick-box-container mark-completed" style={{ color: '#f5a44d' }}>
                            <div onClick={() => { 
                              setSiteReceiptCompletedDatePickerVisible(true);
                              setSiteReceiptCompletedQtyInputVisible(true);
                            }} className="tick-box-sr" style={{ color: '#f5a44d' }}>
                              <CheckOutlined style={{ color: '#f5a44d' }}/>
                            </div>
                          </div>
                        ) : siteReceiptCompletedDatePickerVisible && mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() ? (
                          <div className="date-picker-container">
                            <DatePicker 
                              className="date-picker-small"
                              value={selectedSiteReceiptCompletedDate}
                              onChange={(date) => setSelectedSiteReceiptCompletedDate(date)}
                              format="DD MMM YYYY"
                              placeholder="Select date"
                              size="small"
                              suffixIcon={null} /* Hide the default calendar icon */
                              disabledDate={disabledDate}
                            />
                            <div className="action-icons-container">
                              <div 
                                onClick={() => handleSaveMarkCompleted('site_receipt')}
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setSiteReceiptCompletedDatePickerVisible(false);
                                  setSiteReceiptCompletedQtyInputVisible(false);
                                  setSelectedSiteReceiptCompletedDate(null);
                                }}
                                className="action-icon close"
                              >
                                <CloseOutlined style={{ fontSize: '16px', color: '#f5a44d' }} />
                              </div>
                            </div>
                          </div>
                        ) : (siteReceipt && siteReceipt.completedAt) ? (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">{moment(siteReceipt.completedAt).format('DD MMM YYYY')}</span>
                            {mcPermissions?.site_receipt?.mark_completed && !isProjectOnHold() && <div className="saved-icons-container">
                              <CheckOutlined className="saved-check-icon" style={{ color: '#f5a44d' }} />
                              <EditOutlined 
                                className="edit-icon" 
                                style={{ fill: '#f5a44d' }} 
                                onClick={() => {
                                  setSiteReceiptCompletedDatePickerVisible(true);
                                  setSiteReceiptCompletedQtyInputVisible(true);
                                }}
                              />
                            </div>}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">QTY COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptCompletedQtyInputVisible ? (
                          <div className="qty-container">
                            <Input
                              className="qty-input"
                              value={siteReceiptCompletedQty}
                              onChange={(e) => setSiteReceiptCompletedQty(e.target.value)}
                              style={{ textAlign: 'center' }}
                              type="number"
                              min="1"
                              max={record.qty || 1}
                            />
                            <span className="qty-text">of {record.qty || 1}</span>
                          </div>
                        ) : siteReceiptCompletedQtyIsSaved && siteReceiptCompletedQty ? (
                          <div className="saved-qty-display">
                            <span style={{ color: Number(siteReceiptCompletedQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                              {siteReceiptCompletedQty} of {record.qty || 1}
                            </span>
                            <AuthorizeExcess
                              receivedQty={siteReceiptCompletedQty}
                              expectedQty={record.qty || 1}
                              record={record}
                              currentUser={currentUser}
                              isAuthorized={isSiteReceiptCompletedAuthorized}
                              type="site_receipt"
                              onAuthorize={handleSaveMarkCompleted}
                              authorizationData={authorizationDeliverytoSiteCompletedData}
                              maxAuthorizeValue={maxAuthorizeValue}
                            />
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">LOCATION</div>
                      <div className="field-value">
                        {siteReceiptCompletedQtyInputVisible ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select location"
                              value={selectedSiteReceiptCompletedLocation}
                              onChange={(value) => setSelectedSiteReceiptCompletedLocation(value)}
                              size="small"
                              style={{ width: '100%' }}
                              loading={locationsLoading}
                            >
                              {allLocations && allLocations.map(location => (
                                <Select.Option key={location.id} value={location.id}>
                                  {location.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </div>
                        ) : siteReceiptCompletedDateIsSaved && selectedSiteReceiptCompletedLocation && allLocations ? (
                          <div>{allLocations.find(loc => loc.id === selectedSiteReceiptCompletedLocation)?.name || ''}</div>
                        ) : null}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">UPDATED BY</div>
                      <div className="field-value">{siteReceiptCompletedByUser}</div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS COMPLETED</div>
                      <div className="field-value">
                        {siteReceiptGrossCompleted ? `${siteReceiptGrossCompleted}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : ""}
                      </div>
                    </div>
                  </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label" style={{ marginTop: '10px' }}>SUPPLIER</div>
                       <div className="field-value">
                        {deliverySupplierEditMode ? (
                          <div className="location-container">
                            <Select
                              className="location-select"
                              placeholder="Select supplier"
                              value={selectedDeliverySupplierForTracking}
                              onChange={(value) => setSelectedDeliverySupplierForTracking(value)}
                              size="small"
                              style={{ width: '50px' }}
                              loading={suppliersLoading}
                            >
                              {allSuppliers && allSuppliers.map(supplier => (
                                <Select.Option key={supplier.id} value={supplier.id}>
                                  {supplier.name}
                                </Select.Option>
                              ))}
                            </Select>
                            <div className="action-icons-container">
                              <div 
                                onClick={() => {
                                  handleSupplierSelection('delivery_to_site', deliveryToSite, selectedDeliverySupplierForTracking);
                                  setDeliverySupplierEditMode(false);
                                }}
                                style={{color: '#f5a44d'}} 
                                className="action-icon save"
                              >
                                <SaveOutlined style={{ fontSize: '16px' }} />
                              </div>
                              <div 
                                onClick={() => {
                                  setDeliverySupplierEditMode(false);
                                }}
                                className="action-icon close"
                                style={{color: '#f5a44d'}} 
                              >
                                <CloseOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="saved-supplier-display">
                            <span className="supplier-name">
                            {allSuppliers && selectedDeliverySupplierForTracking ? 
                                  allSuppliers.find(s => s.id === selectedDeliverySupplierForTracking)?.name || '' : ''}
                            </span>
                            {mcPermissions?.site_receipt?.update_supplier && !isProjectOnHold() && <EditOutlined 
                              onClick={() => {
                                setDeliverySupplierEditMode(true);
                              }}
                              className="edit-icon"
                              style={{fill: '#f5a44d'}} 
                            />}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#f5a44d"
                          recordType="site_receipt"
                          record={siteReceipt}
                          canAdd={mcPermissions?.site_receipt?.add_attachments}
                        />
                      </div>
                    </div>
                    <div className="tracking-stage-field">
                      <div className="field-value">
                        <GrvList
                          projectId={project_id}
                          recordType="delivery_to_site"
                          record={siteReceipt}
                          onDataChange={refreshData}
                          mcPermissions={mcPermissions}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div className="tracking-stage installation-stage">
                  <div className="tracking-stage-header">INSTALLATION</div>
                  <div className="tracking-stage-status">
                    <div className={`status-badge ${
                      installation && installation.status === 'completed' ? 'completed' : 
                      (installation && installation.status === 'in_progress' ? 'in-progress' : '')
                    }`}>
                      {installation && installation.status ? 
                        installation.status === 'in_progress' ? 'In Progress' : 
                        installation.status.charAt(0).toUpperCase() + installation.status.slice(1) 
                      : 'Not Started'}
                    </div>
                  </div>
                    <div className="field-group mark-completed">
                      <div className="tracking-stage-field">
                        <div className="field-label">DATE INSTALLED</div>
                        <div className="field-value">
                          {isInstallationReady && !installationDatePickerVisible && !installationDateIsSaved && mcPermissions?.installation?.mark_installed && !isProjectOnHold() &&
                            !(needsAuthorization(siteReceiptCompletedQty, record.qty, maxAuthorizeValue, false)) ? (
                            <div className="tick-box-container mark-completed" style={{ color: '#2ecc71' }}>
                              <div onClick={() => {
                                setInstallationDatePickerVisible(true);
                                setInstallationQtyInputVisible(true);
                              }} className="tick-box-ins" style={{ color: '#2ecc71' }}>
                                <CheckOutlined style={{ color: '#2ecc71' }} />
                              </div>
                            </div>
                          ) : installationDatePickerVisible ? (
                            <div className="date-picker-container">
                              <DatePicker
                                size="small"
                                className="date-picker-small"
                                onChange={(date) => setSelectedInstallationDate(date)}
                                value={selectedInstallationDate}
                                suffixIcon={null} /* Hide the default calendar icon */
                                format="DD MMM YYYY" /* Format the date display */
                                disabledDate={disabledDate}
                              />
                              <div className="action-icons-container">
                                <div
                                  onClick={() => handleSaveMarkCompleted('installation')}
                                  className="action-icon save"
                                >
                                  <SaveOutlined style={{ fontSize: '16px', color:"#2ecc71" }} />
                                </div>
                                <div
                                  onClick={() => {
                                    setInstallationDatePickerVisible(false);
                                    setInstallationQtyInputVisible(false);
                                    setSelectedInstallationDate(null);
                                  }}
                                  className="action-icon close"
                                >
                                  <CloseOutlined style={{ fontSize: '16px', color:"#2ecc71" }} />
                                </div>
                              </div>
                            </div>
                          ) : (installation && installation.completedAt) ? (
                            <div className="saved-date-display">
                              {moment(installation.completedAt).format('DD MMM YYYY')}
                              {mcPermissions?.installation?.mark_installed && !isProjectOnHold() && (
                                    <div className="saved-icons-container">
                                      {/* Grey out and disable icons when installed qty exceeds expected qty and not authorized */}
                                      {(Number(installationQty) > Number(record.qty || 1) && !isInstallationAuthorized) ? (
                                        <>
                                          <CheckOutlined className="saved-check-icon" style={{ color: "#2ecc71", opacity: 0.4 }} />
                                          <div className="edit-date-icon" style={{ opacity: 0.4, cursor: 'not-allowed', pointerEvents: 'none' }}>
                                            <EditOutlined className="edit-icon" style={{ fill: "#2ecc71", opacity: 0.4 }} />
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <CheckOutlined className="saved-check-icon" style={{ color: "#2ecc71" }} />
                                          <div
                                            onClick={() => {
                                              setInstallationDatePickerVisible(true);
                                              setInstallationQtyInputVisible(true);
                                            }}
                                            className="edit-date-icon"
                                          >
                                            <EditOutlined className="edit-icon" style={{ fill: "#2ecc71" }} />
                                          </div>
                                        </>
                                      )}
                                    </div>
                              )}
                            </div>
                          ) : mcPermissions?.installation?.mark_installed && !isProjectOnHold() && siteReceipt && (siteReceipt.status === 'in_progress' || siteReceipt.status === 'completed') && (
                            <div className="tick-box-container">
                              <div
                                onClick={() => {
                                  setInstallationDatePickerVisible(true);
                                  setInstallationQtyInputVisible(true);
                                }}
                                className="tick-box-ins"
                              >
                                <CheckOutlined style={{ fontSize: '16px' }} />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="tracking-stage-field">
                        <div className="field-label">QTY INSTALLED</div>
                        <div className="field-value">
                          {installationQtyInputVisible ? (
                            <div className="qty-container">
                              <Input
                                className="qty-input"
                                value={installationQty}
                                onChange={(e) => setInstallationQty(e.target.value)}
                                style={{ textAlign: 'center' }}
                                type="number"
                                min="1"
                                max={record.qty || 1}
                              />
                              <span className="qty-text">of {record.qty || 1}</span>
                            </div>
                          ) : installationQtyIsSaved && installationQty ? (
                            <div className="saved-qty-display">
                              <span style={{ color: Number(installationQty) > (record.qty || 1) ? '#ff0000' : '#000' }}>
                                {installationQty} of {record.qty || 1}
                              </span>
                              <AuthorizeExcess
                                receivedQty={installationQty}
                                expectedQty={record.qty || 1}
                                record={record}
                                currentUser={currentUser}
                                isAuthorized={isInstallationAuthorized}
                                type="installation"
                                onAuthorize={handleSaveMarkCompleted}
                                authorizationData={authorizationInstallationData}
                                maxAuthorizeValue={maxAuthorizeValue}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                      <div className="tracking-stage-field">
                        <div className="field-label">LOCATION</div>
                        <div className="field-value">
                          {installationQtyInputVisible ? (
                            <div className="location-container">
                              <Select
                                className="location-select"
                                placeholder="Select location"
                                value={selectedInstallationLocation}
                                onChange={(value) => setSelectedInstallationLocation(value)}
                                size="small"
                                style={{ width: '100%' }}
                                loading={locationsLoading}
                              >
                                {allLocations && allLocations.map(location => (
                                  <Select.Option key={location.id} value={location.id}>
                                    {location.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </div>
                          ) : installationQtyIsSaved && selectedInstallationLocation ? (
                            <div className="saved-location-display">
                              {allLocations && allLocations.find(loc => loc.id === selectedInstallationLocation)?.name || ''}
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                      <div className="tracking-stage-field">
                        <div className="field-label">UPDATED BY</div>
                        <div className="field-value">
                          {installationByUser || ""}
                        </div>
                      </div>
                    </div>
                  <div className="field-group">
                    <div className="tracking-stage-field">
                      <div className="field-label">TOTAL / GROSS INSTALLED</div>
                        <div className="field-value">
                          {/* Show empty if installed qty > expected qty and not authorized, otherwise show actual value */}
                          {(Number(installationQty) > Number(record.qty || 1) && !isInstallationAuthorized)
                            ? ""
                            : (installationGross ? `${installationGross}${record.materialType?.uom ? ` ${record.materialType?.uom}` : ''}` : "")}
                        </div>
                    </div>
                    <div className="tracking-stage-field">
                    <div className="field-label">ATTACHMENTS</div>
                      <div className="field-value">
                        <AttachmentContainer
                          onUpdate={refreshData}
                          color="#2ecc71"
                          recordType="installation"
                          record={installation}
                          canAdd={mcPermissions?.installation?.add_attachments}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
            )}
          </Form>
        </Col>
      </Row>
    );
  }
  
  // For other types, dynamically render fields
  return (
    <div style={{ position: 'relative' }}>
      {isSaving && (
        <div style={{
          position: 'absolute',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(255,255,255,0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          pointerEvents: 'all'
        }}>
          <SpinnerComponent fontSize={40} />
        </div>
      )}
      <Row>
        <Col span={24}>
        <Form
          className="ims-doc-fields-form"
          form={formRef}
          name="fields_form"
          onFinish={onFinish}
          initialValues={record}
          onValuesChange={handleValuesChange}
          autoComplete="off"
          layout="vertical"
        >
          <Row gutter={[20, 10]}>
            {fields.map((field, index) => (
              <Col span={8} key={index}>
                {isEditing ? (
                  renderFormItem(field)
                ) : (
                  renderViewItem(field, formValues[field.id] || record[field.id])
                )}
              </Col>
            ))}
          </Row>
        </Form>
      </Col>
    </Row>
    </div>
  );
};

export default ExpandedRow;